/* NUANSE Joias, estudo de layout. Desenha home, coleção, produto, carrinho e pesquisa a partir do pathname.
   ponytail: dados estáticos (assets/carla-*.json) e carrinho em localStorage; quando houver produtos reais, trocar por Liquid + /cart/add.js. */
(function () {
  "use strict";
  var F = "https://cdn.shopify.com/s/files/1/0670/7976/6256/files/";
  var C = "https://cdn.shopify.com/s/files/1/0670/7976/6256/collections/";
  var IMG = {
    hero: NZ.hero,
    about: NZ.about,
    story: NZ.story,
    col: {},
    feat: [F + "feature1.png", F + "feature2.png", F + "feature3.jpg"],
    video:
      "https://cdn.shopify.com/videos/c/o/v/64940e97a37541188afc50902c1a69b1.mov",
    pdp1: F + "gempages_499266826186785565-e88b8039-9a72-4518-bf19-6850214af247.jpg",
    pdp2: F + "image_1782293388811_bkc943.png",
  };
  var COLS = {
    "limited-sale": L("Leva Mais", "All pieces"),
    "best-sellers": L("Mais vendidas", "Best sellers"),
    caes: L("Para quem ama um cão", "For dog lovers"),
    memoria: L("Para lembrar quem partiu", "In loving memory"),
    prendas: L("Prenda para alguém especial", "A gift for someone special"),
    gatos: L("Para quem ama um gato", "For cat lovers"),
    colibris: L("Colibris", "Hummingbirds"),
    aneis: L("Anéis", "Rings"),
    colares: L("Colares", "Necklaces"),
    brincos: L("Brincos", "Earrings"),
    pulseiras: L("Pulseiras", "Bracelets"),
  };
  // ponytail: listas calculadas em load() pela ordem manual da coleção "joias" (evidência nos anúncios)
  var HOME_ROWS = [];
  var PER_PAGE = 28, PER_PAGE_LOCAL = 28;

  var RATE = {};
  // peças com fornecedor ligado no DSers (assets/nz-mapeados.json): só estas entram em packs, "Combina com" e "Completa o conjunto"
  var MAPPED = {};
  // medidas publicadas pelo fornecedor (assets/nz-medidas.json): [PT, EN]
  var SIZES = {};
  var P = {},
    CM = {},
    BODIES = null;
  var app = document.getElementById("app");
  // editor da Shopify: a página vai para dentro da section (.nz-mount) para o Inspector e a seleção de blocos funcionarem
  var DESIGN = !!(window.Shopify && Shopify.designMode);
  function mount() { var m = DESIGN && document.querySelector(".nz-mount"); if (m && app.parentNode !== m) m.appendChild(app); }
  mount();
  var $ = function (s, r) {
    return (r || document).querySelector(s);
  };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  };
  var img = function (f, w) {
    if (/^\/\/|\/\/[^/]*nuanse|\/cdn\/shop\//.test(f) || f.indexOf("/assets/") > -1) return f; // imagens da própria loja (inclui as escolhidas no editor, servidas noutro domínio de pré-visualização)
    return (
      (/^https?:/.test(f) ? f : F + f) +
      (f.indexOf("?") > -1 ? "&" : "?") +
      "width=" +
      (w || 720)
    );
  };
  // data real de entrega: hoje + N dias úteis (política: 1 a 3 de processamento + 8 a 15 de transporte = 9 a 18)
  function eta(n) {
    var d = new Date(), c = 0;
    while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) c++; }
    return NZL.date(d);
  }
  var money = NZL.money;
  // data curta como a referência ("Oct 19" / "19 out")
  function etaShort(n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) c++; } var m = NZL.en ? ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"] : ["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"]; return NZL.en ? m[d.getMonth()] + " " + d.getDate() : d.getDate() + " " + m[d.getMonth()]; }
  var FLAG_UK = '<svg class="eta-flag" viewBox="0 0 60 30" aria-hidden="true"><clipPath id="fk"><path d="M0 0v30h60V0z"/></clipPath><g clip-path="url(#fk)"><path d="M0 0v30h60V0z" fill="#012169"/><path d="M0 0l60 30m0-30L0 30" stroke="#fff" stroke-width="6"/><path d="M0 0l60 30m0-30L0 30" stroke="#C8102E" stroke-width="4"/><path d="M30 0v30M0 15h60" stroke="#fff" stroke-width="10"/><path d="M30 0v30M0 15h60" stroke="#C8102E" stroke-width="6"/></g></svg>';
  var FLAG_PT = '<svg class="eta-flag" viewBox="0 0 60 40" aria-hidden="true"><path d="M0 0h24v40H0z" fill="#046a38"/><path d="M24 0h36v40H24z" fill="#da291c"/><circle cx="24" cy="20" r="7" fill="#ffe900"/><circle cx="24" cy="20" r="4.5" fill="#da291c"/></svg>';
  // preço riscado só com compare_at_price válido da Shopify (maior que o preço); nunca inventado
  // preço riscado: 1.º o compare_at_price real da Shopify; senão, só no UK e se estiver ligado nas definições do tema,
  // o preço de janeiro (o preço para que a loja sobe a 1/1/2027: tem de ser cumprido), com o ⓘ a explicar
  function futPct(h) { for (var s = 0, i = 0; i < h.length; i++) s = (s * 31 + h.charCodeAt(i)) % 9973; return [70, 80, 50, 60, 70, 80][s % 6]; } // todos os produtos UK com preço de janeiro (antes 1/3 ficava sem "Save X%"); os que já tinham % mantêm-no
  function janVal(v, h) { var J = window.NZJAN || {}; if (!J.on || !NZL.en || !h || !v) return 0; var k = futPct(h); return k ? Math.floor(parseFloat(v[1]) / (1 - k / 100)) - 0.05 : 0; }
  function wasVal(v, h) { var c = v && parseFloat(v[5]), pr = v && parseFloat(v[1]); return c > pr ? c : janVal(v, h); }
  function cmp(v, h) { var c = wasVal(v, h), pr = v && parseFloat(v[1]); return c > pr ? Math.round((1 - pr / c) * 100) : 0; }
  function was(v, h) {
    var k = cmp(v, h), real = v && parseFloat(v[5]) > parseFloat(v[1]);
    if (!k) return "";
    if (!real) k = futPct(h);
    var tip = !real ? (window.NZJAN || {}).tip || "Struck-through price: our price from 1 January 2027" : "";
    return '<s class="pdp__cmp">' + money(wasVal(v, h)) + '</s><span class="pdp__save">' + L("Poupa ", "Save ") + k + "%</span>" + (tip ? '<button type="button" class="fut__i" aria-label="' + esc(tip) + '" data-tip="' + esc(tip) + '">i</button>' : "");
  }
  // ⓘ do preço de janeiro: abre ao tocar (telemóvel) e fecha ao tocar fora; nos cartões não segue o link
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(".fut__i");
    document.querySelectorAll(".fut__i.on").forEach(function (x) { if (x !== b) x.classList.remove("on"); });
    if (b) { e.preventDefault(); e.stopPropagation(); b.classList.toggle("on"); }
  }, true);
  // código de moeda junto do preço, como a referência (Carla): "£20.00 GBP"; escondido se a moeda não chegar
  var curTag = NZL.cur ? '<span class="pdp__cur">' + esc(NZL.cur) + "</span>" : "";
  // ícones de linha uniformes (mesma caixa e traço), como os da referência
  var IC24 = {
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 7.8-7.5 9.5-4.3-1.7-7.5-4.9-7.5-9.5V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7z"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/></svg>',
    ret: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4.5v4h4"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/><circle cx="12" cy="15.5" r="1.2"/></svg>',
    // folha de certificado, como o ícone da garantia da Carla
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M4.5 1.5h15v21h-15z"/><path d="M7.5 5.5h9M7.5 9h9M7.5 12.5h3.5M13 12.5h3.5M7.5 16h3.5M13 16h3.5M13 19h3.5"/></svg>',
  };
  // ícones grandes do fim da página (estilo da referência: linha fina, detalhe)
  var IC64 = {
    truck: '<svg viewBox="2 10 58 44" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 20h22v22H22zM44 28h8l6 7v7h-14"/><path d="M47 28v7h11"/><circle cx="28" cy="44" r="4"/><circle cx="50" cy="44" r="4"/><path d="M6 26h11M9 32h8M4 38h13"/></svg>',
    shield: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M32 6c7 5 15 7 22 7v16c0 15-10 25-22 29C20 54 10 44 10 29V13c7 0 15-2 22-7z"/><path d="M23 31l7 7 12-14"/></svg>',
    gift2: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M10 22h44v10H10zM14 32h36v24H14zM32 22v34"/><path d="M32 22c-3-8-13-11-14-5-1 5 8 5 14 5zM32 22c3-8 13-11 14-5 1 5-8 5-14 5z"/></svg>',
    wallet: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M10 20h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4z"/><path d="M10 20l30-8 3 8"/><path d="M42 30h14v12H42a6 6 0 0 1 0-12z"/><circle cx="44" cy="36" r="1.6" fill="currentColor"/></svg>',
    box: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M8 20l20-9 20 9v22l-20 10L8 42z"/><path d="M8 20l20 10 20-10M28 30v22M18 15.5l20 9.5v8"/><path d="M42 36l8-3 8 3v7c0 5-3.5 8-8 10-4.5-2-8-5-8-10z" fill="#fff"/><path d="M46 44l3 3 5-6"/></svg>',
    stars: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M38 14c1.5 9 4 11.5 13 13-9 1.5-11.5 4-13 13-1.5-9-4-11.5-13-13 9-1.5 11.5-4 13-13z"/><path d="M17 8c.8 4.5 2 5.7 6.5 6.5-4.5.8-5.7 2-6.5 6.5-.8-4.5-2-5.7-6.5-6.5C15 13.7 16.2 12.5 17 8zM17 38c.8 4.5 2 5.7 6.5 6.5-4.5.8-5.7 2-6.5 6.5-.8-4.5-2-5.7-6.5-6.5 4.5-.8 5.7-2 6.5-6.5z"/></svg>',
    ret: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 32a18 18 0 1 0 5.3-12.7"/><path d="M14 12v9h9"/><path d="M26 30l6-3 6 3v7l-6 3-6-3z"/><path d="M26 30l6 3 6-3M32 33v7"/></svg>',
    gift: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M10 30l22-9 22 9-22 9z"/><path d="M10 30v14l22 10 22-10V30M32 39v15"/><path d="M24 17c-4-6 2-10 6-5l2 4M40 17c4-6-2-10-6-5l-2 4"/><path d="M20 10l-2-4M44 10l2-4M32 8V3M14 18l-4-2M50 18l4-2"/><circle cx="26" cy="6" r=".8" fill="currentColor"/><circle cx="39" cy="5" r=".8" fill="currentColor"/></svg>',
  };
  var svg = {
    heart:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7.5-4.6-9.5-9.3C1 8 3.4 4.5 7 4.5c2 0 3.6 1.1 5 2.8 1.4-1.7 3-2.8 5-2.8 3.6 0 6 3.5 4.5 7.2C19.5 16.4 12 21 12 21z"/></svg>',
    shield:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9M12 8v13M12 8C10 4 6.5 4.5 7.5 7c.5 1 4.5 1 4.5 1zm0 0c2-4 5.5-3.5 4.5-1-.5 1-4.5 1-4.5 1z"/></svg>',
    truck:
      '<svg viewBox="0 0 64 64"><path d="M4 16h34v26H4zM38 26h12l8 9v7H38z"/><circle cx="16" cy="46" r="5"/><circle cx="48" cy="46" r="5"/></svg>',
    ret: '<svg viewBox="0 0 64 64"><path d="M12 30a20 20 0 1 1 6 14"/><path d="M12 18v12h12"/></svg>',
    lock: '<svg viewBox="0 0 64 64"><rect x="14" y="28" width="36" height="26" rx="3"/><path d="M22 28v-8a10 10 0 0 1 20 0v8"/><circle cx="32" cy="41" r="3"/></svg>',
    box: '<svg viewBox="0 0 64 64"><path d="M8 22l24-12 24 12-24 12z"/><path d="M8 22v22l24 12 24-12V22M32 34v22"/></svg>',
    doc: '<svg viewBox="0 0 64 64"><path d="M16 6h24l10 10v42H16z"/><path d="M24 26h18M24 34h18M24 42h12"/></svg>',
    chat: '<svg viewBox="0 0 64 64"><path d="M8 12h48v30H26l-12 10V42H8z"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8h18v8H3zM7 8v4M11 8v3M15 8v4M19 8v3" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>',
  };

  /* ---------- dados ---------- */
  function load() {
    // produtos reais: coleção "joias" (ordem manual = evidência nos anúncios); carrinho real em /cart.js
    return Promise.all([
      // ponytail: 4 páginas de 250 = teto de 1000 peças; subir o 4 se o catálogo crescer
      Promise.all([1, 2, 3, 4].map(function (pg) { return fetch("/collections/joias/products.json?limit=250&page=" + pg).then((r) => r.json()).catch(function () { return { products: [] }; }); }))
        .then(function (a) { return { products: [].concat.apply([], a.map(function (x) { return x.products; })) }; }),
      fetch("/cart.js").then((r) => r.json()),
      // notas reais (metafields reviews.rating e reviews.rating_count do Judge.me); sem dados, não há estrelas
      // ponytail: 4 páginas de 250 = teto de 1000 peças, como o catálogo acima
      fetch(window.NZ.mapeados).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; }),
      fetch(window.NZ.medidas).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }),
      Promise.all([1, 2, 3, 4].map(function (pg) { return fetch("/collections/all?view=nzrev&page=" + pg).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }); })),
    ]).then(function (d) {
      MAPPED = {};
      (d[2] || []).forEach(function (x) { MAPPED[x] = 1; });
      SIZES = d[3] || {};
      RATE = {};
      d[4].forEach(function (x) { Object.keys((x && x.r) || {}).forEach(function (k) { if (k !== "_") RATE[k] = x.r[k]; }); });
      P = {}; CM = { "limited-sale": [] }; BODIES = {};
      d[0].products.forEach(function (pr) {
        var h = pr.handle;
        addProduct(pr);
        CM["limited-sale"].push(h);
        pr.tags.forEach(function (t) { (CM[t] = CM[t] || []).push(h); });
      });
      var all = CM["limited-sale"];
      CM.colibris = all.filter(function (h) { return /colibri/i.test(P[h].t); });
      // imagens das coleções: cada mosaico com uma foto diferente (antes Colares e Brincos repetiam a mesma)
      var usedImg = {};
      // as fotos dos mosaicos por persona não se repetem nos círculos por peça
      [["colar-abraco-ao-cao", 0], ["colar-abraco-ao-gato", 0], ["brincos-colibri", 0], ["anel-abraco-ao-cao", 1]].forEach(function (t) { if (P[t[0]] && P[t[0]].i[t[1]]) usedImg[P[t[0]].i[t[1]]] = 1; });
      ["colares", "brincos", "pulseiras", "aneis"].forEach(function (c) {
        var hs = rank(CM[c] || []), pick = null;
        for (var k = 0; k < hs.length && !pick; k++) { var f0 = P[hs[k]].i[0]; if (f0 && !usedImg[f0] && !(CM.colibris || []).some(function (x) { return x === hs[k]; }) ) pick = f0; }
        if (!pick && hs.length) pick = P[hs[0]].i[0];
        if (pick) { IMG.col[c] = pick; usedImg[pick] = 1; }
      });
      // filas da home por persona (6 peças cada, sem repetir entre filas)
      var seen = {};
      HOME_ROWS = [[L("Para quem ama um cão", "For dog lovers"), "caes"], [L("Para quem ama um gato", "For cat lovers"), "gatos"], [L("Para lembrar quem partiu", "In loving memory"), "memoria"], [L("Prendas", "Gifts"), "prendas"]]
        .filter(function (r) { return (CM[r[1]] || []).length; })
        .map(function (r) {
          var hs = rank(CM[r[1]]).filter(function (x) { return !seen[x]; }).slice(0, 6);
          hs.forEach(function (x) { seen[x] = 1; });
          return [r[0], r[1], hs];
        });
      // o carrinho da Shopify manda; o local é só o espelho para desenhar
      cart = d[1].items.filter(function (it) { return P[it.handle]; }).map(function (it) {
        var p = P[it.handle], vi = Math.max(0, p.v.findIndex(function (v) { return v[4] === it.variant_id; }));
        return { h: it.handle, vi: vi, q: it.quantity, p: p.v[vi][1], vt: p.v[vi][0] };
      });
      saveCart(true);
    });
  }
  function addProduct(pr) {
    var ids = pr.images.map(function (x) { return x.id; });
    P[pr.handle] = {
      id: pr.id,
      t: pr.title,
      p: pr.variants[0].price,
      i: pr.images.map(function (x) { return x.src; }),
      o: pr.options.filter(function (o) { return o.name !== "Title"; }).map(function (o) { return [o.name, o.values]; }),
      v: pr.variants.map(function (v) { return [v.title, v.price, v.available, v.featured_image ? ids.indexOf(v.featured_image.id) : -1, v.id, v.compare_at_price]; }),
      ty: pr.product_type,
      tg: pr.tags,
    };
    BODIES[pr.handle] = pr.body_html;
  }
  // primeiro o que está em português e até 35 €, depois o resto (ordem estável)
  // ordem das peças winner (espelho da home da Carla, home da Carla ao vivo 15/10): fixas no topo de qualquer grelha; urnas e peças sem envio no fim
  var PIN = ["colar-abraco-ao-cao", "conjunto-colibri-colar-e-brincos", "brincos-colibri", "brincos-gato-com-perola", "colar-abraco-ao-gato", "colar-colibri-colorido", "colar-pata-coracao-e-infinito", "pulseira-ponte-arco-iris", "anel-coleira-com-patas", "anel-abraco-ao-cao", "colar-pedra-da-lua", "brincos-dente-de-leao", "brincos-abraco-ao-gato", "brincos-gota-verde"];
  var LAST = /urna|cinzas|urn|ashes|pulseira-pedra-turquesa/i;
  function rank(hs) {
    var pin = function (x) { var i = PIN.indexOf(x); return i < 0 ? 99 : i; }, last = function (x) { return LAST.test(x + " " + P[x].t) ? 1 : 0; };
    var pt = function (x) { return /[ãçéáíóúê]|Colar|Brincos|Anel|Pulseira/.test(P[x].t) || (NZL.en && /^(colar|brincos|anel|pulseira|conjunto)-/.test(x)) ? 0 : 1; };
    return hs.filter(function (x) { return P[x]; }).map(function (x, i) { return [x, i]; }).sort(function (a, b) {
      return pin(a[0]) - pin(b[0]) || last(a[0]) - last(b[0]) || pt(a[0]) - pt(b[0]) || ((+P[a[0]].p > 35) - (+P[b[0]].p > 35)) || a[1] - b[1];
    }).map(function (a) { return a[0]; });
  }
  function bodies() {
    return Promise.resolve(BODIES || {});
  }

  /* ---------- carrinho (localStorage, só pré-visualização) ---------- */
  var CK = "nz-clone-cart";
  var cart = (function () {
    try {
      return JSON.parse(localStorage.getItem(CK)) || [];
    } catch (e) {
      return [];
    }
  })();
  function syncBundle() {
    var f = document.getElementById("bundle-f"); if (!f) return;
    var n = cartTotals().n, next = n + 1;
    document.querySelectorAll(".bundle__r").forEach(function (r) { r.classList.toggle("is-on", +r.dataset.tier === Math.min(3, next)); });
    f.innerHTML = n === 0 ? L("Aplicado sozinho no carrinho", "Applied automatically in your basket") : n === 1 ? L("Já tens 1 peça no carrinho: com esta ficas com <b>−15%</b>", "You already have 1 piece in your basket: add this one for <b>−15%</b>") : L("Já tens " + n + " peças: com esta ficas com <b>−20%</b>", "You already have " + n + " pieces: add this one for <b>−20%</b>");
  }
  function vid(l) { return P[l.h] && P[l.h].v[l.vi] && P[l.h].v[l.vi][4]; }
  function post(u, b) {
    return fetch(u, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(b) }).then(function (r) { return r.json(); });
  }
  // quantidades exatas na Shopify (remove o que já não está no espelho)
  function pushCart() {
    // catálogo ainda por carregar: sem ids de variante o espelho apagava o carrinho da Shopify (acontecia a cada recarregar a página)
    if (cart.some(function (l) { return !vid(l); })) return Promise.resolve();
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (sc) {
      var up = {};
      sc.items.forEach(function (it) { up[it.variant_id] = 0; });
      cart.forEach(function (l) { var id = vid(l); if (id) up[id] = (up[id] || 0) + l.q; });
      var g = {};
      try { g = JSON.parse(localStorage.getItem("nz-gift")) || {}; } catch (e) {}
      // mensagem de presente: atributo "Mensagem" da encomenda (a mesma regra do carla-offer.js)
      var at = window.NZGIFT ? NZGIFT.attrs() : { "Para oferecer": g.on ? "Sim" : "", Mensagem: (g.on && g.msg) || "", "Mensagem do cartão": "" };
      return post("/cart/update.js", { updates: up, attributes: at });
    });
  }
  window.NZCART = { push: pushCart };
  function saveCart(noPush) {
    try {
      localStorage.setItem(CK, JSON.stringify(cart));
    } catch (e) {}
    if (!noPush) pushCart();
    $(".hdr__dot").hidden = !cart.length;
    syncBundle();
  }
  function cartTotals() {
    var n = 0,
      sub = 0;
    cart.forEach(function (l) {
      n += l.q;
      sub += l.q * Number(l.p);
    });
    var D = window.NZD || [0, 0, 15, 20, 25], pct = n >= 4 ? D[4] : n >= 3 ? D[3] : n === 2 ? D[2] : 0;
    // saldo de boas-vindas (código real SALDO5: 5 €, encomendas a partir de 40 €). Não acumula com Leva/Buy: a Shopify aplica só o maior
    var saldoOn = !!(window.NZSALDO && NZSALDO.has()), saldoOk = saldoOn && sub >= NZL.SALDO_MIN ? NZL.SALDO : 0;
    if (saldoOk > (sub * pct) / 100) pct = 0;
    else saldoOk = 0;
    var disc = (sub * pct) / 100,
      after = sub - disc,
      credit = saldoOk,
      net = after - credit;
    return {
      n: n,
      sub: sub,
      pct: pct,
      disc: disc,
      saldoOn: saldoOn,
      credit: credit,
      after: after,
      ship: net >= NZL.FREE || !n ? 0 : NZL.SHIP,
      total: net + (net >= NZL.FREE || !n ? 0 : NZL.SHIP),
    };
  }
  function addLines(lines, keepOpen, quiet) {
    if (window.NZOFFER) NZOFFER.setPrev(cartTotals().n);
    lines.forEach(function (l) {
      var p = P[l.h], v = p.v[l.vi] || p.v[0];
      var line = cart.find(function (x) { return x.h === l.h && x.vi === l.vi; });
      if (line) line.q += l.q; else cart.push({ h: l.h, vi: l.vi, q: l.q, p: v[1], vt: v[0] });
    });
    saveCart(true);
    post("/cart/add.js", { items: lines.map(function (l) { return { id: vid(l), quantity: l.q }; }) });
    if (keepOpen && !dCart.hidden) renderCart(document.getElementById("dc-body")); else if (!quiet) openCart();
  }
  function addToCart(h, vi, q) {
    if (window.NZOFFER) NZOFFER.setPrev(cartTotals().n);
    var p = P[h],
      v = p.v[vi] || p.v[0];
    var line = cart.find(function (l) {
      return l.h === h && l.vi === vi;
    });
    if (line) line.q += q;
    else cart.push({ h: h, vi: vi, q: q, p: v[1], vt: v[0] });
    saveCart(true);
    post("/cart/add.js", { items: [{ id: v[4], quantity: q }] });
    openCart();
  }

  /* ---------- peças ---------- */
  function card(h, colH) {
    var p = P[h];
    if (!p) return "";
    var url = (colH ? "/collections/" + colH : "") + "/products/" + h;
    return (
      '<div class="gp"><a href="' +
      url +
      '" data-link>' +
      '<div class="gp__img"><img loading="lazy" src="' +
      img(p.i[0], 540) +
      '" alt="' +
      esc(p.t) +
      '">' +
      (p.i[1]
        ? '<img loading="lazy" src="' + img(p.i[1], 540) + '" alt="">'
        : "") +
      (cmp(p.v[0], h) ? '<span class="gp__sale">Sale</span>' : "") +
      "</div>" +
      '<div class="gp__t">' +
      esc(p.t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) +
      // cartão como na referência (Carla): sem estrelas, preço riscado antes do preço e "Save X%" em texto verde
      "</div>" + '<div class="gp__p">' +
      // ordem da referência: riscado, preço, "Save X%"
      (cmp(p.v[0], h) ? '<span class="vh">' + L("Preço normal", "Regular price") + '</span><s class="pdp__cmp">' + money(wasVal(p.v[0], h)) + '</s> <span class="vh">' + L("Preço de saldo", "Sale price") + "</span><b>" + money(p.p) + "</b> " + '<span class="pdp__save">' + L("Poupa ", "Save ") + (parseFloat(p.v[0][5]) > parseFloat(p.v[0][1]) ? cmp(p.v[0], h) : futPct(h)) + "%</span>" : "<b>" + money(p.p) + "</b>") +
      "</div></a></div>"
    );
  }
  function grid(hs, colH, scroll) {
    return (
      '<div class="grid' + (scroll ? ' grid--scroll' : '') + '">' +
      hs
        .map(function (h) {
          return card(h, colH);
        })
        .join("") +
      "</div>"
    );
  }
  function iconsRow(kind) {
    var el = document.getElementById("icons-row");
    if (!kind) {
      el.innerHTML = "";
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.classList.toggle("icons-row--pdp", kind === "pdp");
    el.classList.remove("icons-row--home");
    var rows = kind === "pdp" ? (NZL.en ? [
      [IC64.truck, "Free Shipping", "Free tracked UK delivery on every order from " + money(NZL.FREE).replace(/[.,]00/, "") + "."],
      [IC64.shield, "Built to Last", "Every piece has a 3-year guarantee: if it's faulty, we replace it or refund you."],
      [IC64.gift2, "30-Day Money Back Guarantee", "You can easily return or exchange your order within 30 days, no questions asked."],
      [IC64.wallet, "Secure payment", "Pay securely and reliably with PayPal, Google Pay, Apple Pay, Klarna, Visa, Mastercard and American Express."],
    ] : [
      [IC64.truck, "Portes grátis", "Envio com seguimento grátis a partir de 59 €."],
      [IC64.shield, "Feitas para durar", "Todas as peças têm 3 anos de garantia: se tiver defeito, trocamos ou devolvemos o dinheiro."],
      [IC64.gift2, "30 dias para devolver", "Devolves ou trocas a encomenda em 30 dias, sem explicações."],
      [IC64.wallet, "Pagamento seguro", "Paga com MB WAY, Multibanco, PayPal, Apple Pay, Google Pay ou cartão."],
    ]) : NZL.en ? [
      [svg.truck, "Free UK delivery", "On orders from " + money(NZL.FREE) + "."],
      [svg.doc, "3-year guarantee", "If it's faulty, we'll put it right."],
      [svg.ret, "30 days to return", "No questions asked."],
      [svg.lock, "Secure payment", "Card, Apple Pay, Google Pay, PayPal or Klarna."],
    ] : [
      [svg.truck, "Portes grátis", "A partir de 59 €."],
      [svg.doc, "Garantia de 3 anos", "Se tiver defeito, resolvemos."],
      [svg.ret, "30 dias para devolver", "Sem explicações."],
      [svg.lock, "Pagamento seguro", "MB WAY, Multibanco ou cartão."],
    ];
    el.innerHTML = rows
      .map(function (r) {
        return (
          "<div>" + r[0] + "<h3>" + r[1] + "</h3><p>" + r[2] + "</p></div>"
        );
      })
      .join("");
  }

  /* ---------- páginas ---------- */
  // mosaicos por persona (estilo "My Collections" da referência): foto real de uso, etiqueta branca
  var TILES = [["caes", L("Cão", "Dog"), "colar-abraco-ao-cao", 0], ["gatos", L("Gato", "Cat"), "colar-abraco-ao-gato", 0], ["memoria", L("Memória", "Memory"), "brincos-colibri", 0], ["prendas", L("Prendas", "Gifts"), "anel-abraco-ao-cao", 1]];
  function tileImg(t) {
    var p = P[t[2]];
    if (p && p.i[t[3]]) return p.i[t[3]];
    var hs = rank(CM[t[0]] || []);
    return hs.length ? P[hs[0]].i[0] : "";
  }
  // vistas recentemente: a pessoa retoma onde ficou (guardado só neste browser)
  var SEEN_K = "nz-seen";
  function seenList() { try { return (JSON.parse(localStorage.getItem(SEEN_K)) || []).filter(function (x) { return P[x]; }); } catch (e) { return []; } }
  function markSeen(h) { try { var l = seenList().filter(function (x) { return x !== h; }); l.unshift(h); localStorage.setItem(SEEN_K, JSON.stringify(l.slice(0, 8))); } catch (e) {} }
  function rowHead(t, href) {
    return '<div class="row-c__h"><h2>' + t + '</h2>' + (href ? '<a class="btn-o" href="' + href + '" data-link>' + L("Ver tudo", "View all") + '</a>' : "") + "</div>";
  }
  function home() {
    if (!cfg("NZHOME", NZL.u("/"), "home", home)) return;
    // ordem da referência (Carla): hero só imagem, texto centrado, história (imagem + texto), mais vendidas (8), coleções (4), pulseiras, anéis, brincos, colares (4 cada), ícones
    document.title = L("NUANSE · Joias com significado", "NUANSE · Meaningful jewellery");
    // ordem copiada da home da Carla (17/10): as mesmas peças, pela mesma ordem; o que faltar completa pela nossa ordem
    var ORD = {
      best: ["colar-abraco-ao-cao", "conjunto-colibri-colar-e-brincos", "brincos-abraco-bicolor", "brincos-coruja", "brincos-colibri", "brincos-gato-com-perola", "colar-abraco-ao-gato", "colar-colibri-colorido"],
      pulseiras: ["pulseira-ponte-arco-iris", "pulseira-pedra-turquesa"],
      aneis: ["anel-coleira-com-patas", "anel-pata-e-coracao", "anel-opala-azul-com-luas", "anel-abraco-ao-cao"],
      brincos: ["conjunto-colibri-colar-e-brincos", "brincos-abraco-bicolor", "brincos-coruja", "brincos-colibri"],
      colares: ["colar-abraco-ao-cao", "conjunto-colibri-colar-e-brincos", "colar-abraco-ao-gato", "colar-colibri-colorido"],
    };
    var pick = function (k, pool, n) { var o = (ORD[k] || []).filter(function (x) { return P[x]; }); rank(pool || []).forEach(function (x) { if (o.length < n && o.indexOf(x) < 0) o.push(x); }); return o.slice(0, n); };
    var best = pick("best", CM["best-sellers"] && CM["best-sellers"].length ? CM["best-sellers"] : CM["limited-sale"], 8);
    // home editável (section nz-home): cada bloco do editor vira uma parte da página, pela ordem do editor; campos vazios = o original
    var H = window.NZHOME && NZHOME.length ? NZHOME : [{ t: "hero" }, { t: "note" }, { t: "story" }, { t: "best" }, { t: "cols" }].concat([["pulseiras", "As nossas pulseiras", "Our bracelets"], ["aneis", "Os nossos anéis", "Our rings"], ["brincos", "Os nossos brincos", "Our earrings"], ["colares", "Os nossos colares", "Our necklaces"]].map(function (r) { return { t: "row", col: r[0], pt: r[1], en: r[2], n: 4 }; }));
    var tx = function (b, d) { var v = NZL.en ? b.en : b.pt; return v ? esc(v) : d; };
    var hand = function (b, k, pool) { var ps = (b.ps || []).filter(function (x) { return P[x]; }); return ps.length ? ps.slice(0, b.n || 8) : pick(k, pool, b.n || 4); };
    var row = function (t, c, hs) { return hs.length ? '<section class="sec page-width row-c">' + rowHead(t, c ? "/collections/" + c : "") + grid(hs, c, true) + "</section>" : ""; };
    var HB = {
      hero: function (b) { var h = '<section class="hero hero--c"><img src="' + img(IMG.hero, 1800) + '" alt="' + L("Mulher sorridente com três cães num jardim", "Smiling woman with three dogs in a garden") + '" fetchpriority="high"></section>'; return b.img ? h.replace(/src="[^"]*"/, 'src="' + esc(b.img) + '"').replace(/alt="[^"]*"/, 'alt="' + esc((NZL.en ? b.alt_en : b.alt_pt) || "") + '"') : h; },
      note: function (b) { var HT = function (k, d) { return tx(b, d); }; var h = '<section class="home-note"><p>' + HT("note", L("Cada peça que escolhemos guarda uma história: a do cão que esperava à porta, a do gato que dormia no teu colo, a de quem já cá não está. Joias para os manter perto, todos os dias.", "Every piece we choose carries a story: the dog who waited at the door, the cat who slept on your lap, the one who is no longer here. Jewellery to keep them close, every day.")) + '</p><p class="home-note__n">' + L("✨ Nota: os descontos Leva 2 e Leva 3 entram sozinhos no carrinho.", "✨ Note: Extra discounts are automatically applied at checkout.") + "</p></section>"; var n = NZL.en ? b.n_en : b.n_pt; return n ? h.replace(/<p class="home-note__n">[\s\S]*?<\/p>/, '<p class="home-note__n">' + esc(n) + "</p>") : h; },
      story: function (b) { var h = '<section class="sec page-width story-c"><img loading="lazy" src="' + img(IMG.story || IMG.about || IMG.hero, 900) + '" alt=""><div class="story-c__t"><h2 class="story-c__h">' + L("Sobre nós e as nossas joias", "About Us & Our Jewellery") + "</h2><p><b>" + L("Joias com alma, para quem tem um amor de quatro patas.", "Jewellery with a soul, for anyone with a four-legged love.") + "</b></p><p>" + L("Cada peça começa com uma ideia simples: guardar um laço. O cão que te acompanha, o gato que te escolheu, a memória de quem partiu.", "Every piece starts with one simple idea: keeping a bond close. The dog by your side, the cat who chose you, the memory of someone who has gone.") + "</p><p>" + L("Não é moda rápida. Escolhemos cada desenho pelo que significa e pela forma como aguenta o dia a dia.", "This isn't fast fashion. We pick every design for what it means and how it holds up to everyday wear.") + "</p><p>" + L("Não são só acessórios. São símbolos da tua história, do teu estilo, de quem amas.", "They aren't just accessories. They are symbols of your story, your style and the ones you love.") + "</p><p><b>" + L("Joias pessoais, com significado, feitas para durar.", "Personal, meaningful jewellery, made to last.") + "</b></p></div></section>"; if (b.img) h = h.replace(/src="[^"]*"/, 'src="' + esc(b.img) + '"'); var t = NZL.en ? b.en : b.pt; if (t) h = h.replace(/<h2 class="story-c__h">[\s\S]*?<\/h2>/, '<h2 class="story-c__h">' + esc(t) + "</h2>"); var bd = NZL.en ? b.b_en : b.b_pt; if (bd) h = h.replace(/(<h2 class="story-c__h">[\s\S]*?<\/h2>)[\s\S]*(<\/div><\/section>)$/, "$1" + bd + "$2"); return h; },
      best: function (b) { var pool = CM["best-sellers"] && CM["best-sellers"].length ? CM["best-sellers"] : CM["limited-sale"]; var hs = hand({ ps: b.ps, n: 8 }, "best", pool), c = b.col || "best-sellers"; return hs.length ? '<section class="sec page-width row-c row-best">' + rowHead(tx(b, L("As nossas peças mais vendidas", "Our best-selling pieces of jewellery")), "") + grid(hs, c, true) + '<p class="pdp-more__b"><a class="btn pdp-more__all" href="' + NZL.u("/collections/" + c) + '" data-link>' + L("Ver tudo", "View all") + "</a></p></section>" : ""; },
      cols: function (b) {
        var cs = (b.cs || []).filter(Array.isArray);
        var list = cs.length ? cs.map(function (c) { return [c[0], c[1], c[2]]; }) : [["pulseiras", COLS.pulseiras], ["colares", COLS.colares], ["aneis", COLS.aneis], ["brincos", COLS.brincos]];
        return '<section class="sec page-width types-c"><h2>' + tx(b, L("As nossas coleções", "Our Collections")) + '</h2><div class="types-c__g">' +
          list.map(function (c) { var src = c[2] || (NZ.colimg || {})[c[0]] || (IMG.col[c[0]] ? img(IMG.col[c[0]], 600) : ""); return src ? '<a href="/collections/' + c[0] + '" data-link><img loading="lazy" src="' + src + '" alt=""><span>' + esc(COLS[c[0]] && !cs.length ? COLS[c[0]] : c[1]) + "</span></a>" : ""; }).join("") + "</div></section>";
      },
      row: function (b) { return row(tx(b, ""), b.col, hand(b, b.col, CM[b.col] || [])); },
    };
    app.innerHTML = H.map(function (b) { var h = HB[b.t] ? HB[b.t](b) : ""; if (b.id) h = h.replace(/^(\s*<[a-z0-9]+)/i, '$1 data-nzb="' + b.id + '"'); return b.a ? h.replace(/^(\s*<[a-z0-9]+)/i, "$1 " + b.a) : h; }).join("");
    extras();
    // 3 colunas como a referência (imagem, título, texto), antes dos ícones; textos verdadeiros, não os da Carla
    if (!H.some(function (b) { return b.t === "vals"; })) app.insertAdjacentHTML("beforeend", (function () {
      var V = [
        ["colar-abraco-ao-cao", 1, L("Escolhidas com cuidado", "Chosen with Care"), L("Escolhemos cada desenho pelo que significa, não pelas modas. Cada peça tem de fazer sentido para oferecer e para usar todos os dias.", "We pick every design for what it means, not for trends. Each piece has to feel right to give and right to wear, every day.")],
        ["conjunto-colibri-colar-e-brincos", 0, L("Feitas para usar", "Made to Be Worn"), L("Todas as peças têm a nossa garantia de 3 anos. Se tiver defeito, trocamos ou devolvemos o dinheiro.", "Every piece comes with our 3-year guarantee. If it's faulty, we'll replace it or refund you.")],
        [["brincos-abraco-bicolor", "brincos-abraco-dois-tons-nc-1369", "brincos-abraco-ao-gato", "colar-abraco-ao-gato"].filter(function (x) { return P[x]; })[0] || "brincos-abraco-bicolor", 1, L("Com significado", "Truly Meaningful"), L("Cada desenho guarda uma história: um abraço, uma pata, um pássaro que volta. Joias que dizem o que às vezes as palavras não dizem.", "Each design holds a story: a hug, a paw, a bird that comes back. Jewellery that says what words sometimes can't.")],
      ].filter(function (v) { return P[v[0]]; });
      return V.length ? '<section class="sec page-width vals-c">' + V.map(function (v) { var p = P[v[0]], src = p.i[v[1]] || p.i[0]; return '<div><img loading="lazy" src="' + img(src, 700) + '" alt=""><h3>' + v[2] + "</h3><p>" + v[3] + "</p></div>"; }).join("") + "</section>" : "";
    })());
    // garantias da home no formato da Carla (ícone grande, título e texto centrados), as mesmas da página de produto
    iconsRow("pdp"); document.getElementById("icons-row").classList.add("icons-row--home");
  }

  // coleções da Shopify sem etiqueta própria (ex.: best-sellers, criada à mão para os anúncios): título e ordem manual vêm da própria coleção
  var REMOTE = {};
  function remoteCol(h) {
    var pages = [1, 2, 3, 4].map(function (pg) {
      return fetch("/collections/" + encodeURIComponent(h) + "/products.json?limit=250&page=" + pg).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    });
    return Promise.all([fetch("/collections/" + encodeURIComponent(h) + ".json").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })].concat(pages)).then(function (d) {
      var col = d[0] && d[0].collection, hs = [];
      d.slice(1).forEach(function (x) { (x.products || []).forEach(function (pr) { if (!pr.variants || !pr.variants.length) return; if (!P[pr.handle]) addProduct(pr); if (hs.indexOf(pr.handle) < 0) hs.push(pr.handle); }); });
      return col || hs.length ? { t: col ? col.title : "", hs: hs } : null;
    });
  }
  function collection(h, page) {
    if (!(CM[h] || []).length && h !== "all") {
      if (!(h in REMOTE)) {
        app.innerHTML = '<div style="min-height:70vh"></div>';
        remoteCol(h).then(function (r) {
          REMOTE[h] = r;
          if ((NZL.strip(location.pathname).replace(/\/+$/, "")) === "/collections/" + h) collection(h, page);
        });
        return;
      }
      if (!REMOTE[h] || !REMOTE[h].hs.length) return notFound();
    }
    var manual = !(CM[h] || []).length && REMOTE[h];
    var qs0 = new URLSearchParams(location.search), tipo = manual ? "" : qs0.get("tipo") || "", verTodas = manual || qs0.get("ver") === "todas";
    var TIPOS = { colares: /necklace|pendant|colar/i, brincos: /earring|brinco|stud/i, pulseiras: /bracelet|pulseira|anklet/i, aneis: /\bring\b|anel/i };
    // /collections/all = todas as peças (o CM só tem limited-sale; antes mostrava "0 peças")
    var all = (manual ? manual.hs : CM[h === "all" ? "limited-sale" : h] || []).filter(function (x) {
      return P[x] && (!tipo || !TIPOS[tipo] || TIPOS[tipo].test(P[x].t + " " + x));
    });
    // coleção manual: a ordem da Shopify manda (o produto do anúncio fica em 1.º)
    // limited-sale/all: a ordem da coleção joias na Shopify manda (espelha a limited-sale da Carla); as outras continuam ordenadas por rank
    if (!manual && h !== "limited-sale" && h !== "all") all = rank(all);
    // ?first=h1,h2 (link do anúncio): as peças do anúncio aparecem primeiro, como na coleção de destino da Carla
    var first = (qs0.get("first") || "").split(",").filter(function (x) { return P[x]; });
    if (first.length) all = first.concat(all.filter(function (x) { return first.indexOf(x) < 0; }));
    // como a Carla (Impulse): grelha completa com páginas numeradas, sem o corte das 12 primeiras com "Ver as N peças"
    var total = all.length, curto = false && !verTodas && !tipo && page === 1 && total > 12;
    if (curto) PER_PAGE_LOCAL = 12; else PER_PAGE_LOCAL = PER_PAGE;
    var pages = curto ? 1 : Math.max(1, Math.ceil(all.length / PER_PAGE));
    page = Math.min(Math.max(1, page || 1), pages);
    var slice = curto ? all.slice(0, 12) : all.slice((page - 1) * PER_PAGE, page * PER_PAGE);
    var colT = COLS[h] || (manual && manual.t) || L("Coleção", "Collection");
    document.title = colT + " · NUANSE";
    var link = function (n, label, cls) {
      return (
        '<a class="' +
        (cls || "") +
        '" href="/collections/' +
        h +
        (n > 1 ? "?page=" + n : "") +
        '" data-link>' +
        (label || n) +
        "</a>"
      );
    };
    var pag = "";
    if (pages > 1) {
      var nums = [];
      for (var i = 1; i <= pages; i++)
        if (i <= 3 || i === pages || Math.abs(i - page) <= 1) nums.push(i);
      var last = 0;
      nums.forEach(function (n) {
        if (n - last > 1) pag += "<span>…</span>";
        pag += n === page ? '<span class="cur">' + n + "</span>" : link(n);
        last = n;
      });
      if (page > 1) pag = link(page - 1, "‹", "nx") + pag;
      if (page < pages)
        pag += link(
          page + 1,
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5"><path d="M9 4l8 8-8 8"/></svg>',
          "nx",
        );
    }
    var INTRO = NZL.en ? {
      memoria: ["In loving memory", "To carry the ones you've loved with you, every day."],
      caes: ["For dog lovers", "The friend who waits for you at the door, here or on the other side."],
      gatos: ["For cat lovers", "For the home that's only complete with a cat."],
      prendas: ["A gift for someone special", "Choose the symbol, and we'll send it straight to them."]
    } : {
      memoria: ["Para lembrar quem partiu", "Para trazeres contigo quem amaste, todos os dias."],
      caes: ["Para quem ama um cão", "O amigo que te espera à porta, aqui ou do outro lado."],
      gatos: ["Para quem ama um gato", "Para a casa que só fica completa com um gato."],
      prendas: ["Prenda para alguém especial", "Escolhe o símbolo, nós enviamos para quem recebe."]
    };
    var intro = INTRO[h];
    var chips = '<div class="chips">' + [["", L("Todas", "All")], ["colares", COLS.colares], ["brincos", COLS.brincos], ["pulseiras", COLS.pulseiras], ["aneis", COLS.aneis]].map(function (c) {
      return '<a href="/collections/' + h + (c[0] ? "?tipo=" + c[0] : "") + '" data-link class="chip' + (tipo === c[0] ? " on" : "") + '">' + c[1] + "</a>";
    }).join("") + "</div>";
    // referência (Carla): a coleção abre com a imagem grande e o mesmo texto da home; sem título, filtros nem contagem à vista (o título fica para leitores de ecrã)
    app.innerHTML =
      '<section class="hero hero--c hero--col"><img src="' + img(IMG.hero, 1800) + '" alt=""></section>' +
      // faixa por baixo do banner, como a da Carla; os % vêm dos degraus reais (Definições do tema > Preços)
      (function () { var D = window.NZD || [0, 0, 15, 20, 25]; if ((window.NZCOL || {}).strip) return '<p class="tier-strip">' + esc(NZCOL.strip) + "</p>"; return '<p class="tier-strip">' + L("Leva 2: " + D[2] + "% DESCONTO | Leva 3: " + D[3] + "% DESCONTO | Leva 4: " + D[4] + "% DESCONTO", "Buy 2: " + D[2] + "% OFF | Buy 3: " + D[3] + "% OFF | Buy 4: " + D[4] + "% OFF") + "</p>"; })() +
      '<h1 class="vh">' + (h === "limited-sale" || h === "all" ? L("Todas as peças", "All pieces") : esc(colT)) + "</h1>" +
      // best-sellers como a Carla (best-selling): sem texto de introdução, só a nota do preço riscado
      '<section class="home-note' + (h === "best-sellers" ? ' home-note--bs"><p hidden>' : '"><p>') + ((window.NZCOL || {}).intro ? esc(NZCOL.intro) : intro ? intro[1] : L("Cada peça que escolhemos guarda uma história: a do cão que esperava à porta, a do gato que dormia no teu colo, a de quem já cá não está. Joias para os manter perto, todos os dias.", "Every piece we choose carries a story: the dog who waited at the door, the cat who slept on your lap, the one who is no longer here. Jewellery to keep them close, every day.")) + '</p><p class="home-note__n">' + ((window.NZCOL || {}).note ? esc(NZCOL.note) : L("✨ Nota: os descontos Leva 2 e Leva 3 entram sozinhos no carrinho.", "✨ Note: Extra discounts are automatically applied at checkout.") + (NZL.en && (window.NZJAN || {}).on ? " Struck-through prices are our prices from 1 January 2027." : "")) + "</p></section>" +
      '<section class="page-width' + (h === "best-sellers" ? " col-bs" : "") + '" style="margin-bottom:75px">' + (manual ? "" : chips) + '<p class="col-count">' +
      total + (total === 1 ? L(" produto", " product") : L(" produtos", " products")) + "</p>" +
      grid(slice, h) +
      (curto ? '<div class="center" style="margin-top:30px"><a class="btn btn--all" href="/collections/' + h + '?ver=todas" data-link>' + L("Ver as " + total + " peças", "See all " + total + " pieces") + "</a></div>" : '<nav class="pag" aria-label="' + L("Páginas", "Pages") + '">' + pag + "</nav>") +
      "</section>";
    // best-sellers: a nota do preço riscado passa para depois da grelha (na Carla a grelha vem logo a seguir à faixa)
    if (h === "best-sellers") { var bsN = app.querySelector(".home-note--bs"), bsG = app.querySelector(".col-bs .grid"); if (bsN && bsG) bsG.parentNode.insertBefore(bsN, bsG.nextSibling); }
    iconsRow(null);
    scrollTo(0, 0);
  }

  // Natal: UK 7 a 15 dias úteis (3/12 + 15 = 24/12); PT 9 a 18 dias úteis, sem contar 1/12 e 8/12 (feriados): 26/11 + 18 = 24/12
  function xmasLine() {
    var now = new Date(), y = now.getFullYear(), last = NZL.uk ? new Date(y, 11, 3, 23, 59, 59) : new Date(y, 10, 26, 23, 59, 59);
    if (now > last || now.getMonth() < 9) return "";
    return '<p class="pdp__xmas">' + L("Encomenda até 26 de novembro para chegar antes do Natal.", "Order by 3 December for Christmas delivery.") + "</p>";
  }
  function sizeSlide(h) {
    var z = SIZES[h];
    if (!z || !z.img) return "";
    var base = String(window.NZ.medidas || "").replace(/[^/]*$/, ""), uk = NZL.uk, r = uk ? 11.715 : 11.625, cx = 17, cy = 31, coin;
    if (uk) {
      var pts = [];
      for (var k = 0; k < 12; k++) { var a = Math.PI / 12 + (k * Math.PI) / 6; pts.push((cx + r * Math.cos(a)).toFixed(2) + "," + (cy + r * Math.sin(a)).toFixed(2)); }
      coin = '<polygon points="' + pts.join(" ") + '" fill="#efe2b8" stroke="#bfa45f" stroke-width=".4"/><circle cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.72).toFixed(2) + '" fill="#d9dbe0" stroke="#a9adb5" stroke-width=".3"/>';
    } else {
      coin = '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="#e9d9a6" stroke="#bfa45f" stroke-width=".4"/><circle cx="' + cx + '" cy="' + cy + '" r="' + (r * 0.7).toFixed(2) + '" fill="#d9dbe0" stroke="#a9adb5" stroke-width=".3"/>';
    }
    var ix = Math.max(31, 47 - z.w / 2), iy = cy - z.h / 2, ticks = "";
    // peças grandes (ex.: colibri de 4 cm): a tela cresce e a régua desce, tudo à mesma escala
    var dy = Math.max(0, iy + z.h + 2 - 50), S = Math.max(64, ix + z.w + 3, 64 + dy), mx = S / 2;
    for (var mm = 0; mm <= 50; mm++) {
      var x = 7 + mm, long = mm % 10 === 0;
      ticks += '<line x1="' + x + '" y1="50" x2="' + x + '" y2="' + (long ? 53.2 : mm % 5 === 0 ? 52.2 : 51.4) + '" stroke="#555" stroke-width=".18"/>' + (long ? '<text x="' + x + '" y="56" font-size="2.1" text-anchor="middle" fill="#555">' + mm / 10 + "</text>" : "");
    }
    return '<div class="gal__s gal__scale" role="img" aria-label="' + esc(L("Tamanho real: " + z.lab[0] + ", desenhado à escala ao lado de uma moeda de 1 €", "Actual size: " + z.lab[1] + ", drawn to scale next to a £1 coin")) + '">' +
      '<svg viewBox="0 0 ' + S.toFixed(1) + " " + S.toFixed(1) + '" xmlns="http://www.w3.org/2000/svg" font-family="Jost, sans-serif">' +
      '<rect width="' + S.toFixed(1) + '" height="' + S.toFixed(1) + '" fill="#fff"/>' +
      '<text x="' + mx + '" y="9" font-size="3.3" font-weight="600" text-anchor="middle" fill="#1c1d1d">' + esc(L("Tamanho real: " + z.lab[0], "Actual size: " + z.lab[1])) + "</text>" +
      coin + '<text x="' + cx + '" y="' + (cy + 1.6) + '" font-size="4.4" font-weight="600" text-anchor="middle" fill="#5d5f66">' + (uk ? "£1" : "1 €") + "</text>" +
      '<image href="' + base + z.img + '" x="' + ix.toFixed(2) + '" y="' + iy.toFixed(2) + '" width="' + z.w + '" height="' + z.h + '" preserveAspectRatio="none"/>' +
      '<g transform="translate(0,' + dy.toFixed(2) + ')"><line x1="7" y1="50" x2="57" y2="50" stroke="#555" stroke-width=".25"/>' + ticks +
      '<text x="58.2" y="56" font-size="2.1" fill="#555">cm</text></g>' +
      '<text x="' + mx + '" y="' + (61 + dy).toFixed(2) + '" font-size="2.2" text-anchor="middle" fill="#777">' + esc(L("Desenhado à escala ao lado de uma moeda de 1 €", "Drawn to scale next to a £1 coin")) + "</text>" +
      "</svg></div>";
  }
  function payIcons() {
    var t = document.getElementById("nz-payfull");
    return t ? t.innerHTML.replace(/<\/?div[^>]*>/g, "") : "";
  }
  // estrelas com preenchimento proporcional à nota real (ex.: 3,68 enche 73,6%)
  function stars(r) {
    var pct = Math.max(0, Math.min(100, (Number(r) / 5) * 100));
    return '<span class="st5" role="img" aria-label="' + L("Nota ", "Rated ") + fmtR(r) + L(" em 5", " out of 5") + '"><span class="st5__f" style="width:' + pct.toFixed(1) + '%">★★★★★</span>★★★★★</span>';
  }
  function fmtR(r) { var x = (Math.round(Number(r) * 10) / 10).toFixed(1); return NZL.en ? x : x.replace(".", ","); }
  /* ---------- avaliações (Judge.me, importadas do AliExpress) ----------
     Desenhadas pelo tema a partir dos dados públicos do Judge.me (o widget grátis só tem PT-BR).
     Regras (DMCC 2024): média e número reais; nenhuma avaliação apagada nem escondida; galeria do topo só com fotos de 4 e 5 estrelas;
     lista com fotos primeiro, depois maior nota; as de 1 a 3 estrelas ficam em "Ver todas" e no filtro por estrelas; selo de avaliação importada em cada uma. */
  var REVS = {};
  function revFetch(id) {
    if (REVS[id]) return REVS[id];
    var base = "https://judge.me/reviews/reviews_for_widget?url=ctf1xy-4p.myshopify.com&shop_domain=ctf1xy-4p.myshopify.com&platform=shopify&per_page=30&product_id=" + id + "&page=";
    var get = function (pg) { return fetch(base + pg).then(function (r) { return r.json(); }); };
    REVS[id] = get(1).then(function (d1) {
      var n = Math.min(10, ((d1.pagination || {}).total_pages) || 1), more = [];
      for (var pg = 2; pg <= n; pg++) more.push(get(pg));
      return Promise.all(more).then(function (ds) {
        var all = (d1.reviews || []).concat.apply(d1.reviews || [], ds.map(function (x) { return x.reviews || []; })), seen = {};
        d1.all = all.filter(function (r) { if (seen[r.uuid]) return false; seen[r.uuid] = 1; return true; });
        return d1;
      });
    });
    REVS[id].catch(function () { delete REVS[id]; });
    return REVS[id];
  }
  // nome mascarado e país tal como o AliExpress os mostra (assets/nz-revnames.json, gerado a partir do feedback público do item); nunca inventado
  var RNAMES = null;
  function revNames() {
    if (!RNAMES) RNAMES = fetch(window.NZ.revnames).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
    return RNAMES;
  }
  // traduções fiéis das avaliações (assets/nz-revtr.json: uuid -> [PT-PT, EN-GB, língua do texto importado]); sem entrada, mostra o original
  var RTR = null, TR = {};
  function revTr() {
    if (!RTR) RTR = fetch(window.NZ.revtr).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }).then(function (j) { TR = j || {}; return TR; });
    return RTR;
  }
  var LNG = { en: ["inglês", "English"], pt: ["português", "Portuguese"], es: ["espanhol", "Spanish"], fr: ["francês", "French"] };
  // etiqueta pequena quando o texto mostrado é tradução (língua do original diferente da língua da loja)
  function revTag(r) {
    var x = TR[r.uuid], src = x && x[2], me = NZL.en ? "en" : "pt";
    if (!x || !src || src === me || !revBody(r)) return "";
    return '<span class="rv__tr">' + L("Traduzida do " + (LNG[src] || [src])[0], "Translated from " + (LNG[src] || [, src])[1]) + "</span>";
  }
  function flag(c) {
    return /^[A-Z]{2}$/.test(c || "") ? String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65, 0x1f1e6 + c.charCodeAt(1) - 65) : "";
  }
  function revName(r, nm) {
    var x = nm && nm[r.uuid], n = x && x[0], c = x && x[1];
    return esc(n || L("Cliente", "Customer")) + (c ? ' <span class="rv__fl" title="' + esc(c) + '">' + flag(c) + "</span>" : "");
  }
  function revText(r) {
    // DOMParser não carrega imagens nem corre código do HTML da review
    var d = new DOMParser().parseFromString(String(r.body_html || r.body || "").replace(/<br\s*\/?>/gi, " ").replace(/<\/p>/gi, " "), "text/html");
    return (d.body.textContent || "").replace(/\s+/g, " ").trim();
  }
  // corpo igual ao nome do produto = review só com estrelas e foto (o Judge.me obriga a ter texto): não repetir
  function revBody(r, p) {
    var x = TR[r.uuid], t = x ? (NZL.en ? x[1] : x[0]) || revText(r) : revText(r), o = revText(r), n = function (s) { return String(s || "").toLowerCase().replace(/[^a-z0-9à-ú]/g, ""); };
    return !t || n(o) === n(r.product_title) || n(o) === n(p && p.t) ? "" : t;
  }
  function revDate(r) {
    var d = new Date(r.created_at);
    return isNaN(d) ? "" : d.toLocaleDateString(NZL.en ? "en-GB" : "pt-PT", { day: "numeric", month: "short", year: "numeric" });
  }
  // fotos alojadas nos ficheiros da loja (assets/nz-revpics.json: url original do AliExpress -> Shopify Files); sem entrada, fica a original
  var RPX = null, PIX = {};
  function revPix() {
    if (!RPX) RPX = fetch(String(window.NZ.revtr).replace("nz-revtr.json", "nz-revpics.json")).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }).then(function (j) { PIX = j || {}; return PIX; });
    return RPX;
  }
  function revPics(r) { return (r.pictures_urls || []).map(function (p) { var u = p.original || p.huge || p.compact; return PIX[u] || u; }).filter(Boolean); }
  function rvTh(u, w) { return /cdn\.shopify\.com/.test(u) ? img(u, w) : u; }
  function revItem(r, nm, p) {
    var pics = revPics(r), body = revBody(r, p);
    return '<article class="rv__i"><div class="rv__m">' + stars(r.rating) + "<b>" + revName(r, nm) + "</b><span>" + revDate(r) + "</span></div>" +
      (r.title ? "<h3>" + esc(r.title) + "</h3>" : "") +
      (body ? '<p class="rv__b">' + esc(body) + "</p>" + revTag(r) : "") +
      (pics.length ? '<div class="rv__ph">' + pics.map(function (u, i) { return '<button type="button" data-rvz="' + esc(r.uuid) + '" data-i="' + i + '" aria-label="' + L("Ver foto da avaliação", "View review photo") + '"><img src="' + esc(rvTh(u, 160)) + '" alt="" loading="lazy" width="72" height="72"></button>'; }).join("") + "</div>" : "") +
      "</article>";
  }
  // resumo curto logo a seguir às garantias: média, 3 fotos de 4 e 5 estrelas, 2 citações, ligação para todas
  function mini(list, gal, nm) {
    var p = P[(($("#gal") || {}).dataset || {}).h], rt = p && RATE[(($("#gal") || {}).dataset || {}).h], tr = app.querySelector(".pdp-trust");
    if (!rt || !tr || app.querySelector(".rv-mini")) return;
    var q = list.filter(function (r) { var b = revBody(r, p); return +r.rating >= 4 && b.length > 25 && b.length < 260 && !/plastic|pl[aá]stico|cheap|small|thin|broke|disappoint|poor|not as|didn|doesn|never|wrong|dull|faded|nothing like/i.test(revText(r)); }).slice(0, 2);
    var n = rt[1];
    tr.insertAdjacentHTML("afterend", '<section class="rv-mini" aria-label="' + L("Resumo das avaliações", "Reviews summary") + '">' +
      '<div class="rv-mini__top"><b>' + fmtR(rt[0]) + "</b>" + stars(rt[0]) + "<span>" + n + (n === 1 ? L(" avaliação", " review") : L(" avaliações", " reviews")) + "</span></div>" +
      (gal.length ? '<div class="rv-mini__ph">' + gal.slice(0, 3).map(function (x) { return '<button type="button" data-rvz="' + esc(x[0]) + '" data-i="' + x[1] + '" aria-label="' + L("Ver foto de compradora", "View buyer photo") + '"><img src="' + esc(rvTh(x[2], 200)) + '" alt="" loading="lazy" width="96" height="96"></button>'; }).join("") + "</div>" : "") +
      q.map(function (r) { return '<blockquote class="rv-mini__q"><p>“' + esc(revBody(r, p)) + "”</p>" + (nm[r.uuid] && nm[r.uuid][0] ? "<cite>" + revName(r, nm) + "</cite>" : "") + revTag(r) + "</blockquote>"; }).join("") +
      '<a class="rv-mini__all" href="#pdp-revs">' + L("Ver todas as " + n + " avaliações", "See all " + n + " reviews") + "</a></section>");
    var box = app.querySelector(".rv-mini");
    box.addEventListener("click", function (e) {
      var z = e.target.closest("[data-rvz]");
      if (z) { var r = list.find(function (x) { return x.uuid === z.dataset.rvz; }); if (r) zoom(revPics(r), +z.dataset.i); }
      else if (e.target.closest(".rv-mini__all")) { e.preventDefault(); var s = $("#pdp-revs"); if (s) s.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  }
  function reviews(h) {
    var p = P[h], rt = RATE[h], st = $("#pdp-stars"), sec = $("#pdp-revs");
    if (!p || !rt || !rt[1] || !st || !sec) return;
    st.innerHTML = stars(rt[0]) + "<span>" + fmtR(rt[0]) + L(" com base em ", " based on ") + rt[1] + (rt[1] === 1 ? L(" avaliação", " review") : L(" avaliações", " reviews")) + "</span>";
    st.hidden = false;
    var nr = app.querySelector(".norev");
    if (nr) nr.remove();
    sec.hidden = false;
    sec.innerHTML = '<h2 class="rv__h">' + TF("reviews", "h", L("Avaliações de clientes", "Customer reviews")) + "</h2>" +
      '<p class="rv__eta">' + L("Com seguimento desde o dia do envio: entrega em Portugal em 9 a 18 dias úteis.", "Tracked from the day it ships: UK delivery in 7 to 15 working days.") + "</p>" +
      '<div class="rv__sum"><div class="rv__avg"><b>' + fmtR(rt[0]) + "</b>" + stars(rt[0]) + "<span>" + rt[1] + (rt[1] === 1 ? L(" avaliação", " review") : L(" avaliações", " reviews")) + '</span></div><div class="rv__hist" id="rv-hist"></div></div>' +
      '<div class="rv__gal" id="rv-gal" hidden></div><div id="rv-chips"></div><div class="rv__list" id="rv-list"><p class="rv__load">' + L("A carregar avaliações…", "Loading reviews…") + "</p></div>" +
      '<p class="rv__note" id="rv-note"></p>';
    var shown = 4, filt = 0, list = [], nm = {};
    function draw() {
      // filtros: nota exata (1 a 5), 4+ estrelas, com fotos, sem fotos
      var FL = { "4p": function (r) { return +r.rating >= 4; }, ph: function (r) { return revPics(r).length > 0; }, np: function (r) { return !revPics(r).length; } };
      var src = filt ? list.filter(FL[filt] || function (r) { return +r.rating === +filt; }) : list;
      var chips = '<div class="rv__chips">' + [["0", L("Todas", "All")], ["4p", L("4★ ou mais", "4★ & up")], ["ph", L("Com fotos", "With photos")], ["np", L("Sem fotos", "Without photos")]].map(function (c) { return '<button type="button" data-rvf="' + c[0] + '" aria-pressed="' + (String(filt || 0) === c[0]) + '">' + c[1] + "</button>"; }).join("") + "</div>";
      var cut = src.slice(0, shown);
      var el = $("#rv-list");
      if (!el) return;
      var ch = $("#rv-chips"); if (ch) ch.innerHTML = chips + (filt ? '<p class="rv__f">' + src.length + L(" avaliações", " reviews") + "</p>" : "");
      el.innerHTML = 
        (cut.length ? cut.map(function (r) { return revItem(r, nm, p); }).join("") : '<p class="rv__load">' + L("Sem avaliações com esta nota.", "No reviews with this rating.") + "</p>") +
        (src.length > shown ? '<button type="button" class="rv__more" data-rvmore>' + L("Ver mais avaliações (" + (src.length - shown) + ")", "Show more reviews (" + (src.length - shown) + ")") + "</button>" : "");
    }
    Promise.all([revFetch(p.id), revNames(), revTr(), revPix()]).then(function (dd) {
      var d = dd[0];
      nm = dd[1] || {};
      if ($("#gal") && $("#gal").dataset.h !== h) return;
      // ordem: 4 e 5 estrelas primeiro (com foto antes), depois as de 1 a 3, que aparecem em "Ver todas" e no filtro por estrelas
      list = d.all.slice().sort(function (a, b) {
        // no topo: 4 e 5 estrelas com foto e sem queixa no texto (ex.: "plastic bird" fica na ordem normal por nota, visível)
        var top = function (r) { return +r.rating >= 4 && revPics(r).length > 0 && !/plastic|pl[aá]stico|cheap|small|thin|broke|disappoint|poor|not as/i.test(revText(r)) ? 1 : 0; };
        return top(b) - top(a) || b.rating - a.rating || (revPics(b).length > 0) - (revPics(a).length > 0) || new Date(b.created_at) - new Date(a.created_at);
      });
      var good = list.filter(function (r) { return +r.rating >= 4; }).length;
      // transparência: as avaliações importadas de outros canais de venda desta peça são assinaladas (todas ou algumas)
      var imp = list.filter(function (r) { return (r.transparency_badges || []).indexOf("review_collected_from_another_provider") > -1; }).length;
      var EU = /^(ES|FR|NL|DE|PL|IT|PT|BG|CZ|LV|BE|IE|AT|SE|DK|FI|GR|RO|HU|SK|SI|HR|LT|EE|LU)$/, cc = list.map(function (r) { return (nm[r.uuid] || [])[1] || ""; });
      var gb = cc.indexOf("GB") > -1, eu = cc.some(function (c) { return EU.test(c); }), other = cc.some(function (c) { return c && c !== "GB" && !EU.test(c); });
      if (imp && $("#rv-note")) $("#rv-note").textContent = L("Avaliações da página do nosso fornecedor para esta mesma peça. ", "Reviews from our supplier's listing for this exact piece. ") + (gb && eu
        ? L("Avaliações desta mesma peça, de compradores no Reino Unido, na Europa e noutros países.", "Reviews of this exact piece from buyers in the UK, Europe and beyond.")
        : eu && other
          ? L("Avaliações desta mesma peça, de compradores na Europa e noutros países.", "Reviews of this exact piece from buyers in Europe and beyond.")
          : L("Avaliações desta mesma peça, de compradores em vários países.", "Reviews of this exact piece from buyers worldwide."));
      shown = Math.max(1, Math.min(4, good || 4));
      var hist = (d.histogram || []).slice().sort(function (a, b) { return b.rating - a.rating; });
      $("#rv-hist").innerHTML = hist.map(function (x) {
        return '<button type="button" data-rvf="' + x.rating + '" aria-label="' + L("Ver as de " + x.rating + " estrelas", "Show " + x.rating + "-star reviews") + '"><span>' + x.rating + ' ★</span><i><em style="width:' + (x.percentage || 0) + '%"></em></i><span>' + x.frequency + "</span></button>";
      }).join("");
      // galeria do topo: só fotos de avaliações de 4 e 5 estrelas
      var gal = [];
      list.forEach(function (r) { if (+r.rating >= 4) revPics(r).forEach(function (u, i) { gal.push([r.uuid, i, u]); }); });
      if (gal.length) {
        var g = $("#rv-gal");
        g.innerHTML = '<h3 class="rv__gh">' + L("Fotos de compradores", "Buyers' photos") + '</h3><div class="rv__gs">' + gal.slice(0, 24).map(function (x) {
          return '<button type="button" data-rvz="' + esc(x[0]) + '" data-i="' + x[1] + '" aria-label="' + L("Ver foto", "View photo") + '"><img src="' + esc(rvTh(x[2], 240)) + '" alt="" loading="lazy" width="120" height="120"></button>';
        }).join("") + "</div>";
        g.hidden = false;
      }
      draw();
      mini(list, gal, nm);
      // cartões da comunidade (como a referência): só avaliações de 4 e 5 estrelas com texto, nomes mascarados tal como no AliExpress
      var cg = $(".nz-comm__g"), cm = list.filter(function (r) { return +r.rating >= 4 && revBody(r, p).length > 15; }).slice(0, 9);
      if (cg && cm.length) {
        cg.innerHTML = cm.map(function (r) { var n = (nm[r.uuid] && nm[r.uuid][0]) || L("Comprador AliExpress", "AliExpress buyer"), cc = (nm[r.uuid] || [])[1] || ""; return '<article class="nz-cc"><div class="nz-cc__top"><span class="nz-cc__av">' + esc(n.charAt(0).toUpperCase()) + '</span><span class="nz-cc__n"><b>' + esc(n) + "</b>" + (cc ? '<small>' + flag(cc) + " " + esc(revDate(r)) + "</small>" : '<small>' + esc(revDate(r)) + "</small>") + '</span><i class="nz-cc__dots">•••</i></div><p>' + esc(revBody(r, p)) + '</p><div class="nz-cc__f">' + stars(r.rating) + "</div></article>"; }).join("");
        var wrap = $("#nz-comm .page-width");
        if (wrap && !wrap.querySelector(".nz-comm__nav")) { wrap.insertAdjacentHTML("beforeend", '<button type="button" class="nz-comm__nav nz-comm__nav--l" aria-label="' + L("Anterior", "Previous") + '">‹</button><button type="button" class="nz-comm__nav nz-comm__nav--r" aria-label="' + L("Seguinte", "Next") + '">›</button>'); wrap.addEventListener("click", function (e) { var b = e.target.closest(".nz-comm__nav"); if (b) cg.scrollBy({ left: (b.classList.contains("nz-comm__nav--l") ? -1 : 1) * 354, behavior: "smooth" }); }); }
        $("#nz-comm").hidden = false;
      }
    }).catch(function () {
      var el = $("#rv-list");
      if (el) el.innerHTML = '<p class="rv__load">' + L("Não foi possível carregar as avaliações agora.", "Couldn't load the reviews right now.") + "</p>";
    });
    sec.addEventListener("click", function (e) {
      var z = e.target.closest("[data-rvz]"), f = e.target.closest("[data-rvf]"), m = e.target.closest("[data-rvmore]");
      if (z) {
        var r = list.find(function (x) { return x.uuid === z.dataset.rvz; });
        if (r) zoom(revPics(r), +z.dataset.i);
      } else if (f) { filt = f.dataset.rvf === "0" ? 0 : f.dataset.rvf; shown = 6; draw(); }
      else if (m) { shown += 6; draw(); }
    });
  }
  // media reais da Shopify (imagens e vídeos) vêm de /products/<h>.js; o products.json só traz imagens
  var MEDIA = {};
  // texto do editor (section nz-pdp) quando preenchido; senão o original
  // atributos do editor (data-shopify-editor-block) no primeiro elemento do bloco
  function EA(cfgList, k, html) { var b = (cfgList || []).find(function (x) { return x.t === k; }); return b && b.a ? String(html).replace(/^(\s*<[a-z0-9]+)/i, "$1 " + b.a) : html; }
  function TF(k, f, d) { var b = (window.NZPDP || []).find(function (x) { return x.t === k; }); var v = b && b.f && b.f[f + (NZL.en ? "_en" : "_pt")]; return v ? esc(v) : d; }
  // textos do carrinho (Definições do tema > Carrinho)
  function TC(k, d) { var v = (window.NZCART || {})[k]; return v ? esc(v) : d; }
  function TX(k, d) { var b = (window.NZPDP || []).find(function (x) { return x.t === k; }); var v = b && (NZL.en ? b.en : b.pt); return v ? esc(v) : d; }
  // configuração do editor (templates JSON): vem no HTML da página; ao navegar sem recarregar, pede só a section
  function cfg(name, url, sec, then) {
    if (window[name] !== undefined) return true;
    fetch(url + (url.indexOf("?") < 0 ? "?" : "&") + "sections=" + sec).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }).then(function (j) {
      var m = String((j || {})[sec] || "").match(new RegExp("window\\." + name + "=(\\[[\\s\\S]*?\\]);"));
      try { window[name] = m ? JSON.parse(m[1]) : []; } catch (x) { window[name] = []; }
      then();
    });
    return false;
  }
  function product(h, colH) {
    if (!cfg("NZPDP", NZL.u("/products/" + encodeURIComponent(h)), "pdp", function () { product(h, colH); })) return;
    var p = P[h];
    if (!p) return notFound();
    if (!(h in MEDIA)) {
      app.innerHTML = '<div style="min-height:70vh"></div>';
      fetch("/products/" + encodeURIComponent(h) + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }).then(function (j) {
        MEDIA[h] = (j && j.media) || null;
        if (/\/products\//.test(location.pathname) && decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || "") === h) product(h, colH);
      });
      return;
    }
    document.title = p.t + " · NUANSE";
    markSeen(h);
    var calm = (p.tg || []).indexOf("memoria") > -1;
    var sel =
      p.v[0] && p.v[0][0] !== "Default Title" ? p.v[0][0].split(" / ") : [];
    var qty = 1,
      imgI = 0;
    // sugestões: a coleção do URL se for específica; senão a persona da peça (cão, gato, memória), depois o tipo
    var simCol = colH && colH !== "limited-sale" && colH !== "joias" && CM[colH] ? colH
      : ["caes", "gatos", "memoria", "colares", "brincos", "aneis", "pulseiras"].filter(function (t) { return (p.tg || []).indexOf(t) > -1; })[0];
    var others = (CM[simCol] || CM["limited-sale"] || [])
      .filter(function (x) {
        return x !== h && P[x];
      })
      .slice(0, 5);
    var opts = p.o
      .map(function (o, oi) {
        return (
          // comprimento único da corrente: já aparece nas vantagens, não ocupa uma linha
          '<div class="opt' + (o[1].length === 1 && /\d\s?(cm|mm|"|inch)|''/i.test(o[1][0]) ? " opt--one" : "") + '"><span class="lbl">' +
          esc(o[0]) +
          '</span><div class="sw" role="group" aria-label="' +
          esc(o[0]) +
          '">' +
          o[1]
            .map(function (val) {
              return (
                '<button type="button" data-oi="' +
                oi +
                '" data-val="' +
                esc(val) +
                '" aria-pressed="' +
                (sel[oi] === val) +
                '">' +
                esc(val) +
                "</button>"
              );
            })
            .join("") +
          "</div></div>"
        );
      })
      .join("");
    // acima da dobra: galeria, título, preço, opções, bundles, presente e botão. O resto em acordeões fechados.
    var acc = function (id, t, body) { return '<details class="acc"' + (id ? ' id="' + id + '"' : "") + "><summary>" + t + "</summary><div>" + body + "</div></details>"; };
    // slides: fotos do produto e, em 2.º, o desenho à escala quando há medida publicada pelo fornecedor
    // galeria a partir dos media (imagens e vídeos); a 1.ª fica; o 1.º media real do fornecedor passa para 2.º com legenda; o desenho à escala a seguir
    var fileOf = function (u) { return String(u || "").split("?")[0].split("/").pop().replace(/\.(webp|jpe?g|png)$/i, ""); };
    var media = (MEDIA[h] || []).filter(function (m) { return m.media_type === "image" || m.media_type === "video"; });
    if (!media.length) media = p.i.map(function (f) { return { media_type: "image", src: f, alt: "" }; });
    // galeria só com fotos simples do produto e vídeos: imagens geradas por IA (ficheiro *-ia) ficam de fora
    var noAi = media.filter(function (m) { return !/-ia$/i.test(fileOf(m.src || (m.preview_image || {}).src)); });
    if (noAi.length) media = noAi;
    var zl = [];
    var realIdx = -1;
    media.forEach(function (m, i) { if (realIdx < 0 && i > 0 && /\breal\b/i.test(m.alt || "")) realIdx = i; });
    if (realIdx > 1) media.splice(1, 0, media.splice(realIdx, 1)[0]);
    var slides = media.map(function (m, i) {
      var cap = i === 1 && /\breal\b/i.test(m.alt || "") ? '<span class="gal__real">' + (m.media_type === "video" ? L("Vídeo real do fornecedor, sem IA", "Real video from our supplier, not AI") : L("Foto real do fornecedor, sem IA", "Real photo from our supplier, not AI")) + "</span>" : "";
      if (m.media_type === "video") {
        var srcs = (m.sources || []).filter(function (x) { return x.format === "mp4"; }).sort(function (a, b) { return Math.abs((+a.width || 9999) - 420) - Math.abs((+b.width || 9999) - 420); });
        var poster = m.preview_image ? img(m.preview_image.src, 900) : "";
        return ["video:" + poster, '<div class="gal__s gal__v"><video muted loop playsinline autoplay preload="metadata"' + (poster ? ' poster="' + poster + '"' : "") + ' aria-label="' + esc(m.alt || p.t) + '">' + srcs.slice(0, 1).map(function (x) { return '<source src="' + x.url + '" type="video/mp4">'; }).join("") + "</video>" + cap + "</div>"];
      }
      var u = m.src || (m.preview_image || {}).src;
      zl.push(u);
      return [u, '<button type="button" class="gal__s" data-zoom="' + (zl.length - 1) + '" aria-label="' + L("Ampliar imagem ", "Zoom image ") + (i + 1) + '"><img ' + (i ? 'loading="lazy" ' : 'fetchpriority="high" ') + 'src="' + img(u, 1100) + '" alt="' + esc(i ? m.alt || "" : p.t) + '">' + cap + (/-ia$/i.test(fileOf(u)) ? '<span class="gal__ai">' + L("Imagem ilustrativa (IA)", "Illustrative image (AI)") + "</span>" : "") + "</button>"];
    });
    var scale = sizeSlide(h);
    // galeria como a Carla: só fotos do produto (sem slides de oferta nem de escala)
    var scaleI = slides.findIndex(function (s) { return s[0] === "scale"; });
    var tg0 = p.tg || [], calmO = tg0.indexOf("memoria") > -1 && tg0.indexOf("caes") < 0 && tg0.indexOf("gatos") < 0;
    if (false && !calmO && slides.length) {
      var fr = money(NZL.FREE).replace(/[.,]00/, "");
      slides.splice(1, 0, ["offer", '<div class="gal__s gal__o" role="img" aria-label="' + esc(L("Leva 2 −15% · Leva 3 −20% + portes grátis a partir de " + fr, "Buy 2 15% off · Buy 3 20% off + free delivery over " + fr)) + '"><div class="go">' +
        '<span class="go__k">' + L("Leva mais, poupa mais", "Buy more, save more") + "</span>" +
        '<div class="go__r"><span>' + L("Leva 2", "Buy 2") + "</span><b>" + L("−15%", "15% off") + "</b></div>" +
        '<div class="go__r"><span>' + L("Leva 3", "Buy 3") + "</span><b>" + L("−20%", "20% off") + "</b></div>" +
        '<div class="go__r"><span>' + L("Leva 4+", "Buy 4+") + "</span><b>" + L("−25%", "25% off") + "</b></div>" +
        '<p class="go__f">' + L("+ portes grátis a partir de " + fr, "+ free delivery over " + fr) + "</p>" +
        '<span class="go__n">' + L("Desconto automático no carrinho", "Applied automatically in your basket") + "</span></div></div>"]);
      if (scaleI > 0) scaleI++;
    }
    // índice de uma imagem do products.json (variantes) no carrossel
    var slideOf = function (i) {
      var fn = fileOf(p.i[i]);
      for (var k = 0; k < slides.length; k++) if (fileOf(slides[k][0]) === fn) return k;
      return 0;
    };
    var gHtml =
      '<div class="pdp"><div class="pdp__gal"><div class="gal" id="gal" data-h="' + esc(h) + '">' +
      slides.map(function (s) { return s[1]; }).join("") +
      "</div>" +
      // lupa por cima da foto (telemóvel), como a Carla: abre a foto em grande
      (zl.length ? '<button type="button" class="gal__zoom" aria-label="' + L("Ampliar imagem", "Zoom image") + '"><svg viewBox="0 0 64 64" width="18" height="18" aria-hidden="true"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42" stroke="currentColor" stroke-width="5" fill="none"/></svg></button>' : "") +
      (slides.length > 1 ? '<div class="gal__dots" aria-hidden="true">' + slides.map(function (s, i) { return "<i" + (i ? "" : ' class="on"') + "></i>"; }).join("") + "</div>" +
        '<div class="pdp__thumbs">' + slides.map(function (s, i) {
          var th = s[0] === "offer" ? '<span class="th-scale th-offer">' + L("−15%<br>−20%", "15%<br>20% off") + "</span>" : s[0] === "scale" ? '<span class="th-scale">' + L("Tamanho", "Size") + "</span>" : /^video:/.test(s[0]) ? '<span class="th-vid">' + (s[0].slice(6) ? '<img src="' + s[0].slice(6) + '" alt="">' : "") + "<i>▶</i></span>" : '<img src="' + img(s[0], 160) + '" alt="">';
          return '<button type="button" data-img="' + i + '" aria-current="' + (i === 0) + '" aria-label="' + L("Imagem ", "Image ") + (i + 1) + '">' + th + "</button>";
        }).join("") + "</div>" : "") +
      "</div>" +
      "";
    // blocos da PDP: ordem, visibilidade e textos vêm da section nz-pdp (editor da Shopify); sem section, ordem de sempre
    var PB = {
      pill: '<span class="pdp__pill"><svg class="seal" viewBox="0 0 100 100" aria-hidden="true"><defs><path id="sealc" d="M50 50m-34 0a34 34 0 1 1 68 0a34 34 0 1 1-68 0"/></defs><circle cx="50" cy="50" r="47"/><text><textPath href="#sealc">' + L("ESCOLHIDA · COM AMOR · ESCOLHIDA · COM AMOR ·", "CHOSEN · WITH LOVE · CHOSEN · WITH LOVE ·") + '</textPath></text><path d="M50 66s-15-9-15-19c0-5 4-9 8-9 3 0 5 2 7 4 2-2 4-4 7-4 4 0 8 4 8 9 0 10-15 19-15 19z"/></svg>' + TX("pill", L("Escolhida com amor pela NUANSE", "Chosen with Love by NUANSE")) + "</span>",
      stars: '<a class="pdp__stars" id="pdp-stars" href="#pdp-revs" hidden></a>',
      title: // título curto como na referência (Carla): só o nome da peça, sem a parte ", Gift for…" (que fica para o SEO)
      '<h1 class="pdp__t">' + esc(p.t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) + "</h1>",
      price: '<div class="pdp__price"><span id="pdp-price">' + money(p.p) + '</span>' + curTag + '<span id="pdp-was">' + was(p.v[0], h) + "</span>" + "</div>",
      badge: cmp(p.v[0], h) ? "" : '<div class="pdp__badge"><span class="badge">' + TX("badge", L("Poupa 15% em 2", "Save 15% on 2")) + "</span></div>",
      ticks: '<div class="pdp__after">' +
      (SIZES[h] && SIZES[h].lab ? '<button type="button" class="pdp__real" data-img="' + Math.max(1, scaleI) + '">' + svg.ruler + L("Tamanho real: ", "Actual size: ") + esc(L(SIZES[h].lab[0], SIZES[h].lab[1])).replace(/ x /, " × ") + " <u>" + L("ver à escala", "see to scale") + "</u></button>" : "") +
      '<ul class="pdp__ticks" id="pdp-ticks"></ul></div>',
      options: opts,
      qty: // quantidade como na referência (Carla): rótulo QUANTIDADE e caixa − 1 +
      '<div class="opt pdp__qty"><span class="lbl">' + L("Quantidade", "Quantity") + '</span><div class="qty"><button type="button" data-q="-1" aria-label="' + L("Menos", "Less") + '">−</button><span id="pdp-q">1</span><button type="button" data-q="1" aria-label="' + L("Mais", "More") + '">+</button></div></div>',
      stock: // stock baixo como na referência (Carla): ponto vermelho por cima do botão, só com o stock real da Shopify (≤ 5); ?nzfix=1 mostra o componente com dados de exemplo
      '<p class="pdp__stock" id="pdp-stock" hidden></p>',
      atc: '<button class="atc" id="atc" type="button">' + TX("atc", L("Adicionar ao carrinho", "Add to cart")) + '</button>',
      eta: // entrega como a referência: duas metades centradas, ponto verde + data curta, bandeira + FREE Shipping (o limite real fica escrito)
      '<p class="pdp__eta pdp__eta--k pdp__eta--a"><span><i class="eta-dot"></i>' + L("Enviado até <b>", "Ships by <b>") + etaShort(3) + "</b></span></p>",
      eta2: '<p class="pdp__eta pdp__eta--k pdp__eta--b"><span>' + (NZL.en ? FLAG_UK : FLAG_PT) + "<b>" + L("Portes GRÁTIS", "FREE") + "</b>&nbsp;" + L("acima de " + money(NZL.FREE).replace(/[.,]00/, ""), "Shipping over " + money(NZL.FREE).replace(/[.,]00/, "")) + "</span></p>",
      trust: '<ul class="pdp-trust pdp-trust--c pdp-trust--k">' +
      '<li><span class="pt-ico">' + IC24.doc + '</span><span>' + L("Garantia de 3 anos em todas as peças", "3-Year Craftsmanship Guarantee") + '</span></li>' +
      '<li><span class="pt-ico">' + IC24.truck + '</span><span>' + L("Entrega com seguimento", "Tracked Delivery to Your Door") + '</span></li>' +
      '<li><span class="pt-ico">' + IC24.ret + '</span><span>' + L("Devolução fácil em 30 dias", "Easy 30-Day Returns") + '</span></li>' +
      '<li><span class="pt-ico">' + IC24.lock + '</span><span>' + L("Pagamento seguro e simples", "Secure & Simple Checkout") + '</span></li>' +
      "</ul>",
      bundle: // tabela da referência (Carla): degraus reais de desconto; portes grátis só onde o total passa o limite
      '<div class="bmt"><div class="bmt__h"><b>' + TX("bundle", L("Leva mais, poupa mais", "Buy More, Save More")) + "</b><i>" + TF("bundle", "sub", L("Desconto automático no carrinho", "Auto-applied in your cart")) + "</i></div>" +
      [[2, 15], [3, 20], [4, 25]].map(function (r) { var free = r[0] * p.p * (1 - (window.NZD || [0, 0, 15, 20, 25])[r[0]] / 100) >= NZL.FREE; return '<div class="bmt__r"><b>' + r[0] + (r[0] === 4 ? "+" : "") + L(" peças", " Items") + "</b><span>" + r[1] + L("% desc.", "% Off") + (free ? L(" + portes grátis", " + Free Shipping") : "") + "</span></div>"; }).join("") +
      '<div class="bmt__f">' + TF("bundle", "foot", L("Mistura quaisquer peças da loja", "Mix and match any pieces")) + "</div></div>" +
      '<div class="saldo-pdp" data-saldo-pdp hidden>' + L("Tens <b>" + money(NZL.SALDO) + "</b> de saldo na tua carteira NUANSE, aplicado no carrinho. Não soma com o Leva 2/3: aplicamos sempre o desconto maior.", "You have <b>" + money(NZL.SALDO) + "</b> credit in your NUANSE wallet, applied in your basket. It doesn't stack with Buy 2/3: we always apply the bigger one.") + '</div>',
      desc: '<h2 class="pdp__dh">' + TX("desc", L("Guarda quem amas perto do coração, hoje e sempre.", "Keep the ones you love close to your heart, today and always.")) + "</h2>" +
      '<div class="pdp__desc" id="pdp-desc"></div>',
      accs: '<div class="accs">' +
      acc("acc-sig", L("O significado", "The meaning"), "") +
      acc("acc-faq", L("Perguntas frequentes", "FAQs"), "") +
      acc("acc-ship", L("Garantia, envios e devoluções", "Guarantee, delivery and returns"), NZL.en ? "<p><b>Guarantee:</b> every piece has a 3-year guarantee. If a fault appears, email us a photo and we'll replace it or refund you.</p><p><b>Delivery:</b> we prepare your order in 1 to 3 working days and tracked delivery to the UK takes " + NZL.ETA[0] + " to " + NZL.ETA[1] + " working days in total. Sent by our supplier from outside the UK, with tracking by email. Delivery is " + money(NZL.SHIP) + ", free on orders from " + money(NZL.FREE) + ".</p><p><b>Returns:</b> 30 days to change your mind, no questions asked, and we refund your original delivery too. Faulty or wrong item? We cover the return postage. <a href=\"/policies/refund-policy\" data-native>Full returns policy</a>.</p>" : "<p><b>Garantia:</b> garantia legal de 3 anos. Se aparecer um defeito, escreve-nos com uma foto e trocamos ou devolvemos o dinheiro.</p><p><b>Envios:</b> preparamos em 1 a 3 dias úteis e o transporte demora 8 a 15 dias úteis: no total, 9 a 18 dias úteis. Enviado pelo nosso fornecedor, fora da UE, com seguimento por email. Portes de 4,90 € para Portugal, grátis a partir de 59 €.</p><p><b>Devoluções:</b> 30 dias depois de receber, sem explicações. Escreve para contacto@nuanse.online.</p>") +
      "</div>",
      reviews: '<section class="pdp-revs" id="pdp-revs" hidden></section>' +
      '<div class="norev">' + L("<b>Ainda sem avaliações.</b> Somos uma loja nova: quando comprares, pedimos a tua opinião e publicamos boa ou má. Só clientes verificados.", "<b>No reviews yet.</b> We're a new shop: after you buy, we'll ask for your honest opinion and publish it, good or bad. Verified customers only.") + '</div>',
      below: pdpBelow(p, h, others),
      related: pdpMore(h, others),
    };
    var ORD = (window.NZPDP && NZPDP.length ? NZPDP : null), INFO = ["pill", "stars", "title", "price", "badge", "ticks", "options", "qty", "stock", "atc", "eta", "eta2", "trust", "bundle", "desc", "accs", "reviews"];
    var order = ORD ? ORD.map(function (x) { return x.t; }) : INFO.concat(["below", "related"]);
    // bloco tirado no editor fica escondido (não apagado): o resto do código continua a encontrar os ids
    var put = function (k) { var h = String(PB[k]).replace(/^(\s*<[a-z0-9]+)/i, '$1 data-nzb="' + k + '"'); return order.indexOf(k) > -1 ? EA(window.NZPDP, k, h) : '<div hidden>' + h + "</div>"; };
    var seq = order.concat(Object.keys(PB).filter(function (k) { return order.indexOf(k) < 0; }));
    app.innerHTML = gHtml + '<div class="pdp__info">' + seq.filter(function (k) { return INFO.indexOf(k) > -1; }).map(put).join("") + "</div></div>" + seq.filter(function (k) { return INFO.indexOf(k) < 0; }).map(put).join("");
    // selo verde logo a seguir ao preço: vai para dentro da linha do preço (fica igual a antes, e continua um bloco próprio no editor)
    (function () { var pr = app.querySelector(".pdp__info > .pdp__price"), bd = pr && pr.nextElementSibling; if (bd && bd.classList.contains("pdp__badge")) { var sp = bd.firstElementChild; if (sp) { [].slice.call(bd.attributes).forEach(function (a) { if (/^data-/.test(a.name)) sp.setAttribute(a.name, a.value); }); pr.appendChild(sp); } bd.remove(); } })();
    syncBundle();
    // garantias finais da referência: 4 blocos com ícone no fim da página
    iconsRow("pdp");
    scrollTo(0, 0);

    $("#pdp-desc").innerHTML = (BODIES[h] || "").replace(/<a [^>]*>|<\/a>/g, "");
    function variantIndex() {
      if (!sel.length) return 0;
      var t = sel.join(" / ");
      var i = p.v.findIndex(function (v) {
        return v[0] === t;
      });
      return i < 0 ? 0 : i;
    }
    // stock baixo por variante (inventário real da Shopify, só com seguimento e venda bloqueada sem stock); ?nzstock=N simula para testes
    function stockFor(vi) {
      var m = location.search.match(/[?&]nzstock=(-?\d+)/), arr = (window.NZSTOCK || {})[h];
      var q = m ? +m[1] : arr && arr.length ? arr[vi] : null;
      return typeof q === "number" ? Math.max(0, q) : null;
    }
    function syncStock() {
      var el = $("#pdp-stock"); if (!el) return;
      var q = stockFor(variantIndex());
      var mx = window.NZSTOCKMAX || 5;
      el.hidden = !(q !== null && q >= 1 && q <= mx);
      if (!el.hidden) el.innerHTML = "<i></i>" + L("Só restam " + q + " em stock!", "Only " + q + " left in stock!");
    }
    window.NZAPP.pdpStock = syncStock;
    setTimeout(syncStock, 0);
    function setQty(n) {
      qty = Math.max(1, Math.min(10, n));
      $("#pdp-q").textContent = qty;
      if (window.NZAPP.pdpRender) window.NZAPP.pdpRender();
    }
    // vídeos: mudos, em loop, a tocar sozinhos (iOS exige muted + playsinline)
    app.querySelectorAll("#gal video").forEach(function (v) { v.muted = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); });
    var gal = $("#gal");
    function mark(i) {
      imgI = i;
      app.querySelectorAll("[data-img]").forEach(function (b) { b.setAttribute("aria-current", String(+b.dataset.img === i)); });
      app.querySelectorAll(".gal__dots i").forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    function setImg(i) {
      gal.scrollTo({ left: gal.clientWidth * i, behavior: "smooth" });
      mark(i);
    }
    gal.addEventListener("scroll", function () { var i = Math.round(gal.scrollLeft / gal.clientWidth); if (i !== imgI) mark(i); }, { passive: true });
    app.querySelector(".pdp").addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      if (b.dataset.zoom) zoom(zl, +b.dataset.zoom);
      else if (b.classList.contains("gal__zoom")) { var cs = gal.children[imgI]; zoom(zl, cs && cs.dataset.zoom ? +cs.dataset.zoom : 0); }
      else if (b.dataset.img) setImg(+b.dataset.img);
      else if (b.dataset.oi) {
        sel[+b.dataset.oi] = b.dataset.val;
        b.parentNode.querySelectorAll("button").forEach(function (x) {
          x.setAttribute("aria-pressed", String(x === b));
        });
        var v = p.v[variantIndex()];
        syncStock();
        $("#pdp-price").textContent = money(v[1]);
        $("#pdp-was").innerHTML = was(v, h);
        // barra fixa acompanha a variante escolhida
        var sbS = bar.querySelector('select[data-soi="' + b.dataset.oi + '"]'); if (sbS) sbS.value = b.dataset.val;
        var sbB = bar.querySelector(".n b"), sbW = bar.querySelector(".n s");
        if (sbB) sbB.textContent = money(v[1]);
        if (sbW) { sbW.hidden = !cmp(v, h); sbW.textContent = cmp(v, h) ? money(wasVal(v, h)) : ""; }
        if (v[3] > -1) setImg(slideOf(v[3]));
      } else if (b.dataset.q) {
        setQty(qty + +b.dataset.q);
      } else if (b.id === "atc") {
        b.textContent = L("Adicionado ✓", "Added ✓"); b.dataset.ok = 1;
        b.classList.add("is-ok");
        setTimeout(function () { b.classList.remove("is-ok"); b.textContent = L("Adicionar ao carrinho", "Add to cart"); if (window.NZAPP.pdpRender) window.NZAPP.pdpRender(); }, 1400);
        if (window.NZAPP.pdpBuy) addLines(window.NZAPP.pdpBuy()); else addToCart(h, variantIndex(), qty);
      }
    });
    // barra fixa de adicionar ao carrinho quando o botão sai do ecrã
    var bar = document.getElementById("sticky-atc");
    // barra fixa como a da Carla (computador): miniatura, nome curto, preço riscado + preço, opções em listas e botão largo
    var v0 = p.v[variantIndex()];
    bar.innerHTML =
      '<img src="' +
      img(p.i[0], 120) +
      '" alt=""><div class="n"><span class="sa__t">' +
      esc(p.t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) +
      '</span><span class="sa__p"><s' + (cmp(v0, h) ? ">" + money(wasVal(v0, h)) : " hidden>") + "</s><b>" +
      money(v0 ? v0[1] : p.p) +
      "</b></span></div>" +
      p.o.map(function (o, oi) {
        return o[1].length > 1 ? '<label class="sa__o"><span class="vh">' + esc(o[0]) + '</span><select data-soi="' + oi + '">' + o[1].map(function (val) { return "<option" + (sel[oi] === val ? " selected" : "") + ">" + esc(val) + "</option>"; }).join("") + "</select></label>" : "";
      }).join("") +
      '<button class="atc" type="button">' + L("Adicionar ao carrinho", "Add to cart") + '</button>';
    bar.querySelectorAll("select[data-soi]").forEach(function (sl) {
      sl.addEventListener("change", function () {
        var b0 = [].slice.call(app.querySelectorAll('.pdp [data-oi="' + sl.dataset.soi + '"]')).filter(function (x) { return x.dataset.val === sl.value; })[0];
        if (b0) b0.click();
      });
    });
    bar.hidden = false;
    // altura real da barra (no telemóvel tem 2 ou 3 linhas): a aba do saldo sobe por cima dela sem a tapar
    document.documentElement.style.setProperty("--nz-sa-h", bar.offsetHeight + "px");
    bar.querySelector("button").onclick = function () {
      if (window.NZAPP.pdpBuy) addLines(window.NZAPP.pdpBuy()); else addToCart(h, variantIndex(), qty);
    };
    if (window._nzObs) window._nzObs.disconnect();
    window._nzObs = new IntersectionObserver(function (en) {
      bar.classList.toggle(
        "on",
        !en[0].isIntersecting && en[0].boundingClientRect.top < 0,
      );
    });
    window._nzObs.observe(document.getElementById("atc"));
    window.NZAPP.pdpVariant = variantIndex;
    window.NZAPP.pdpQty = function () { return qty; };
    window.NZAPP.pdpSetQty = setQty;
    window.NZAPP.pdpRender = null;
    window.NZAPP.pdpBuy = null;
    if (window.NZOFFER) NZOFFER.pdpEnhance(h);
    (function () { var g = app.querySelector("#nz-faq .nz-faq__g"), qs = app.querySelectorAll("#acc-faq .pfaq details"); if (!g || !qs.length) return; [].slice.call(qs, 0, 8).forEach(function (d) { g.appendChild(d.cloneNode(true)); }); app.querySelector("#nz-faq").hidden = false; var acc = app.querySelector("#acc-faq"); if (acc) acc.hidden = true; })();
    reviews(h);
    extras();
  }

  // secções da referência por baixo da PDP: combina com, campanha real, história (as garantias finais vivem no #icons-row)
  function pdpBelow(p, h, others) {
    var u = others[0], up = u && P[u], fr = money(NZL.FREE).replace(/[.,]00/, "");
    // ordem e estilo da referência: recomendações, editorial (imagem à esquerda), história (imagem à direita)
    return '<section class="pdp-x page-width">' +
      "</section>" +
      (others.length ? '<section class="sec page-width pdp-rec"><h3 class="pdp-rec__h">' + L("Temos a certeza de que também vais gostar destas", "We are sure you'll love these too") + "</h3>" + grid(others, null, true) + "</section>" : "") +
      '<section class="sec page-width nz-split"><img loading="lazy" src="' + (NZ.about || NZ.story) + '" alt=""><div class="nz-split__t"><div class="nz-kick">' + L("Leva mais, poupa mais", "Buy more, save more") + '</div><div class="nz-big">' + L("Leva 2 com −15%, 3 com −20%, 4 ou mais com −25%.", "Buy 2, save 15%. Buy 3, save 20%. Buy 4+, save 25%.") + "</div><p>" +
      L("O desconto aplica-se sozinho no carrinho a qualquer combinação de peças, e os portes são grátis a partir de " + fr + ".", "The discount applies automatically in your cart to any mix of pieces, and delivery is free over " + fr + ".") + "</p><p>" + L("Uma para ti, outra para oferecer.", "One for you, one to give.") + "</p></div></section>" +
      '<section class="sec page-width nz-split nz-split--r"><img loading="lazy" src="' + (NZ.story || NZ.about) + '" alt=""><div class="nz-split__t"><div class="nz-kick">' + L("Escolhidas com amor", "Chosen with love") + '</div><div class="nz-big">' + L("Pequenas peças, amores grandes.", "Small pieces, big love.") + "</div><p>" +
      L("Na NUANSE escolhemos joias com significado: o animal que nos espera à porta, a pessoa de quem temos saudades.", "At NUANSE we choose jewellery that means something: the pet waiting by the door, the person you miss.") + "</p><p>" +
      L("Todas têm garantia de 3 anos e 30 dias para mudares de ideias. Se alguma coisa não estiver bem, escreve-nos e resolvemos.", "Every piece has a 3-year guarantee and 30 days to change your mind. If anything isn't right, write to us and we'll sort it.") + "</p></div></section>";
  }
  // grelha "Mais peças" (8) e perguntas frequentes em cartões, como a referência
  function pdpMore(h, others) {
    var more = rank(CM["limited-sale"] || []).filter(function (x) { return x !== h && others.indexOf(x) < 0 && P[x]; }).slice(0, 8);
    return (more.length ? '<section class="sec page-width pdp-more"><h2 class="pdp-more__h">' + L("Mais peças para completar o teu estilo", "More Beautiful Pieces to Complete Your Look") + "</h2>" + grid(more, "limited-sale", true) + '<p class="pdp-more__b"><a class="btn pdp-more__all" href="' + NZL.u("/collections/limited-sale") + '" data-link>' + L("Ver tudo", "View all") + "</a></p></section>" : "") +
      '<section class="nz-comm" id="nz-comm" hidden><div class="page-width"><h2 class="nz-comm__h">' + L("O que dizem os compradores", "What buyers are saying") + '</h2><p class="nz-comm__s">' + L("Avaliações desta peça na página do nosso fornecedor", "Reviews of this piece from our supplier's listing") + '</p><div class="nz-comm__g"></div></div></section>' +
      '<section class="nz-faq" id="nz-faq" hidden><div class="page-width"><h2 class="nz-faq__h">' + L("Perguntas frequentes", "Frequently asked questions") + '</h2><div class="nz-faq__g"></div></div></section>';
  }

  function zoom(list, i) {
    var z = document.createElement("div");
    z.className = "zoom";
    z.setAttribute("role", "dialog");
    z.setAttribute("aria-label", L("Imagem ampliada", "Zoomed image"));
    z.innerHTML = '<button type="button" class="zoom__x" aria-label="' + L("Fechar", "Close") + '">✕</button><div class="zoom__in"><img src="' + img(list[i], 2000) + '" alt=""></div>';
    document.body.appendChild(z);
    document.body.style.overflow = "hidden";
    z.addEventListener("click", function (e) {
      if (e.target.closest(".zoom__x")) { z.remove(); document.body.style.overflow = ""; return; }
      var im = z.querySelector("img"), r = im.getBoundingClientRect();
      if (z.classList.toggle("on")) {
        var inn = z.querySelector(".zoom__in");
        inn.scrollLeft = ((e.clientX - r.left) / r.width) * inn.scrollWidth - innerWidth / 2;
        inn.scrollTop = ((e.clientY - r.top) / r.height) * inn.scrollHeight - innerHeight / 2;
      }
    });
  }

  function cartPage() {
    document.title = L("Carrinho · NUANSE", "Cart · NUANSE");
    // como a referência: título "Cart", ligação para continuar a comprar, peças à esquerda e resumo cinzento à direita
    app.innerHTML =
      '<section class="sec page-width cart-pg"><div class="cart-pg__h"><h1>' + TC("title", L("Carrinho", "Cart")) + '</h1><a href="' + NZL.u("/collections/limited-sale") + '" data-link>' + L("Continuar a comprar", "Continue shopping") + '</a></div><div id="cart-page"></div></section>';
    iconsRow(null);
    renderCart(document.getElementById("cart-page"));
  }
  function contact() {
    document.title = L("Contacto · NUANSE", "Contact · NUANSE");
    app.innerHTML =
      '<section class="sec page-width" style="max-width:720px"><div class="sec-h"><h2>' + L("Contacto", "Contact") + '</h2></div><div class="rich" style="padding:0"><p>' + L("Escreve-nos para <b>contacto@nuanse.online</b>. Respondemos em 24 horas úteis, de segunda a sexta.", "Email us at <b>contacto@nuanse.online</b>. We reply within 24 working hours, Monday to Friday.") + '</p></div></section>';
    iconsRow(null);
  }
  function search(q) {
    q = (q || "").trim().toLowerCase();
    var hs = q
      ? Object.keys(P).filter(function (h) {
          return P[h].t.toLowerCase().indexOf(q) > -1;
        })
      : [];
    document.title = L("Pesquisa · NUANSE", "Search · NUANSE");
    app.innerHTML =
      '<section class="sec page-width"><div class="sec-h"><h2>' + L("Pesquisa", "Search") + '</h2></div><form action="/search" class="center" style="margin-bottom:30px"><input name="q" value="' +
      esc(q) +
      '" style="font:inherit;padding:10px 14px;border:1px solid var(--line);width:min(480px,100%)" aria-label="' + L("Pesquisar", "Search") + '"></form>' +
      (q
        ? '<p class="col-count">' +
          hs.length +
          L(" resultados", " results") + "</p>" +
          grid(hs.slice(0, 48))
        : "") +
      "</section>";
    iconsRow(null);
  }
  function notFound() {
    app.innerHTML =
      '<section class="sec page-width center"><div class="sec-h"><h2>' + L("Página não encontrada", "Page not found") + '</h2></div><a class="btn" href="/" data-link>' + L("Voltar ao início", "Back to home") + '</a></section>';
    iconsRow(null);
  }

  /* ---------- gavetas ---------- */
  // página do carrinho simples como a da Carla (Impulse): peças à esquerda (foto, nome, opções, quantidade, "Remove", preço), caixa cinzenta com Subtotal e CHECK OUT
  function renderCartPage(el) {
    var t = cartTotals();
    if (!cart.length) {
      el.innerHTML = '<div class="center cp__empty"><p>' + TC("empty", L("O teu carrinho está vazio.", "Your cart is currently empty.")) + '</p><a class="btn" href="' + NZL.u("/collections/limited-sale") + '" data-link>' + L("Continuar a comprar", "Continue shopping") + "</a></div>";
      return;
    }
    var items = cart.map(function (l, i) {
      var p = P[l.h];
      var opt = l.vt && l.vt !== "Default Title" ? String(l.vt).split(" / ").map(function (val, k) { var on = p.o[k] && p.o[k][0]; return "<p class=\"cp__o\">" + (on ? "<b>" + esc(on) + ":</b> " : "") + esc(val) + "</p>"; }).join("") : "";
      return '<div class="cp__it"><a class="cp__img" href="' + NZL.u("/products/" + l.h) + '" data-link><img src="' + img(p.i[0], 300) + '" alt=""></a><div class="cp__in"><a class="cp__t" href="' + NZL.u("/products/" + l.h) + '" data-link>' + esc(p.t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) + "</a>" + opt +
        '<div class="cp__qrow"><div class="qty cp__q"><button type="button" data-cq="' + i + '" data-d="-1" aria-label="' + L("Menos", "Less") + '">−</button><span>' + l.q + '</span><button type="button" data-cq="' + i + '" data-d="1" aria-label="' + L("Mais", "More") + '">+</button></div>' +
        '<div class="cp__pr">' + money(l.q * l.p) + "</div></div>" +
        '<button type="button" class="cp__rm" data-rm="' + i + '">' + L("Remover", "Remove") + "</button></div></div>";
    }).join("");
    var net = t.after - t.credit;
    el.innerHTML = '<div class="cp__items">' + items + "</div>" +
      '<div class="cp__sum">' +
      (t.disc ? '<div class="cp__row cp__row--d"><span>' + L("Descontos", "Discounts") + " (" + L("LEVA ", "BUY ") + (t.n >= 4 ? "4+" : t.n) + ')</span><span>−' + money(t.disc) + "</span></div>" : "") +
      (t.credit ? '<div class="cp__row cp__row--d"><span>' + L("Saldo NUANSE", "NUANSE credit") + "</span><span>−" + money(t.credit) + "</span></div>" : "") +
      '<div class="cp__row"><span>' + L("Subtotal", "Subtotal") + "</span><span>" + money(net) + "</span></div>" +
      '<button class="cp__co" type="button" data-checkout>' + L("Finalizar compra", "Check out") + "</button>" +
      '<p class="cp__note">' + L("Portes, impostos e códigos de desconto calculados no checkout.", "Shipping, taxes, and discount codes calculated at checkout.") + "</p></div>";
  }
  function renderCart(el) {
    if (el && el.id === "cart-page") return renderCartPage(el);
    var t = cartTotals();
    var ht = document.querySelector(".drawer__h--cart span");
    if (ht) ht.textContent = TC("title", L("O teu carrinho", "Your cart")) + " • " + t.n; // separador da Carla: "Your cart • 2"
    if (!cart.length) {
      el.innerHTML = '<div class="center" style="padding:40px 0"><p>' + TC("empty", L("O teu carrinho está vazio.", "Your basket is empty.")) + '</p><p style="color:#555;font-size:15px">' + (window.NZSALDO && NZSALDO.has() ? L("O teu saldo de " + money(NZL.SALDO) + " está guardado na tua carteira NUANSE.", "Your " + money(NZL.SALDO) + " credit is waiting in your NUANSE wallet.") : L("Começa pelas peças mais escolhidas.", "Start with our most-loved pieces.")) + '</p><a class="btn" href="/collections/limited-sale" data-link style="font-size:16px;padding:13px 26px">' + L("Ver as favoritas", "See the favourites") + '</a></div>';
      return;
    }
    var n = t.n, next = n >= 4 ? "" : n === 3 ? L("Junta mais 1 peça para teres <b>25%</b> de desconto", "Add <b>1</b> more product to get <b>25% off</b>") : n === 2 ? L("Junta mais 1 peça para teres <b>20%</b> de desconto", "Add <b>1</b> more product to get <b>20% off</b>") : L("Junta mais 1 peça para teres <b>15%</b> de desconto", "Add <b>1</b> more product to get <b>15% off</b>");
    var fill = n >= 4 ? 100 : n === 3 ? 66 : n === 2 ? 33 : 0;
    var tiers = '<div class="tiers"><p>' + (next || L("🎉 Tens o desconto máximo: <b>25%</b>", "🎉 You've got the maximum discount: <b>25%</b>")) + '</p><div class="tiers__track"><i style="width:' + fill + '%"></i>' +
      [[L("15% DESC.", "15% OFF"), 2], [L("20% DESC.", "20% OFF"), 3], [L("25% DESC.", "25% OFF"), 4]].map(function (x, k) { return '<span class="tiers__n' + (n >= x[1] ? " on" : "") + '" style="left:' + [33, 66, 100][k] + '%"><em><svg viewBox=\"0 0 24 24\" width=\"16\" height=\"16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\"><path d=\"M3 12V4h8l10 10-8 8z\"/><circle cx=\"7.5\" cy=\"8.5\" r=\"1.5\"/></svg></em><small>' + x[0] + "</small></span>"; }).join("") + "</div></div>";
    // linha como a da Carla (UpCart): nome, opções com o nome da opção, quantidade; preço numa linha própria à direita com o código da moeda
    var cur = NZL.en && NZL.cur ? " " + NZL.cur : "", mc = function (x) { return money(x) + cur; };
    var lines = cart.map(function (l, i) {
      var p = P[l.h], v = p.v[l.vi], wasL = cmp(v, l.h) ? l.q * wasVal(v, l.h) : 0;
      var opt = l.vt && l.vt !== "Default Title" ? String(l.vt).split(" / ").map(function (val, k) { var on = p.o[k] && p.o[k][0]; return "<small>" + (on ? esc(on) + ": " : "") + esc(val) + "</small>"; }).join("") : "";
      return '<div class="cl"><img src="' + img(p.i[0], 200) + '" alt=""><div style="flex:1"><div class="cl__t">' + esc(p.t.split(/,\s*(?=gift|prenda|presente|keepsake|pet memorial)/i)[0]) + '<button class="rm" data-rm="' + i + '" aria-label="' + L("Remover", "Remove") + '"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#9a9a9a" stroke-width="1.6"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button></div>' +
        opt +
        '<div class="cl__row"><div class="qty qty--sm"><button data-cq="' + i + '" data-d="-1" aria-label="' + L("Menos", "Less") + '">−</button><span>' + l.q + '</span><button data-cq="' + i + '" data-d="1" aria-label="' + L("Mais", "More") + '">+</button></div></div>' +
        '<div class="cl__pr">' + (wasL ? '<s class="cl__was">' + mc(wasL) + "</s> " : "") + "<b>" + mc(l.q * l.p) + "</b>" + (wasL ? '<em class="cl__save">(' + L("Poupas ", "Save ") + mc(wasL - l.q * l.p) + ")</em>" : "") + "</div></div></div>";
    }).join("");
    var after = t.after - t.credit, falta = Math.max(0, NZL.FREE - after);
    el.innerHTML = tiers + lines +
      '<div class="drawer__f">' +
      (t.pct ? '<div class="row"><span>' + L("Descontos", "Discounts") + ' <span class="tag"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>' + L("LEVA ", "BUY ") + (n >= 4 ? "4+" : n >= 3 ? "3" : "2") + "</span></span><span>−" + money(t.disc) + "</span></div>" : "") +
      (t.saldoOn ? (t.credit ? '<div class="row saldo-row"><span>🎁 ' + L("Saldo NUANSE", "NUANSE credit") + '</span><span>−' + money(t.credit) + "</span></div>" : '<div class="row saldo-row saldo-row--off"><span>🎁 ' + (t.sub >= NZL.SALDO_MIN ? L("O desconto Leva vale mais do que o saldo: aplicámos o maior, o saldo fica guardado", "Your Buy 2/3 discount is bigger than your credit: we applied the bigger one, your credit stays saved") : L("Junta mais 1 peça e usas o teu saldo de 5 €", "Add 1 more piece to use your " + money(NZL.SALDO) + " credit")) + '</span></div>') : "") +
      '<div class="row"><span>' + L("Portes", "Delivery") + '</span><span>' + (t.ship ? money(t.ship) + ' <small style="color:#666">(' + L("faltam " + money(falta) + " para grátis", money(falta) + " away from free") + ")</small>" : L("Grátis", "Free")) + "</span></div>" +
      '<button class="atc atc--co" type="button" data-checkout>' + TC("co", L("Finalizar compra", "Checkout")) + '</button>' +
      // o checkout só soma os portes depois da morada: dizer já o total final para o número não "saltar"
      '<p class="co-tot">' + (t.ship ? L("Total com portes: <b>", "Total with delivery: <b>") + money(t.total) + "</b><small>" + L("No checkout, os portes aparecem depois da morada.", "At checkout, delivery shows after you enter your address.") + "</small>" : "Total: <b>" + money(t.total) + "</b>" + L(", portes grátis", ", free delivery")) + "</p>" +
      '<div class="co-icons">' + (document.querySelector(".nz-payicons") ? document.querySelector(".nz-payicons").innerHTML : "") + "</div>" +
      '<p class="note">' + L("IVA incluído. Pagas no ecrã seguro da Shopify.", "You pay on Shopify's secure checkout.") + '</p></div>';
      if (window.NZOFFER) NZOFFER.cartExtras(el, t);
  }

  var overlay = document.getElementById("overlay"),
    dCart = document.getElementById("drawer-cart"),
    dMenu = document.getElementById("drawer-menu"),
    sBar = document.getElementById("searchbar");
  function closeAll() {
    [overlay, dCart, dMenu, sBar].forEach(function (x) {
      x.hidden = true;
      x.classList.remove("is-closing");
    });
    document.body.style.overflow = "";
  }
  // fecho animado (gavetas deslizam para fora, overlay desvanece)
  function closeAnimated() {
    var open = [overlay, dCart, dMenu, sBar].filter(function (x) { return !x.hidden; });
    if (!open.length || matchMedia("(prefers-reduced-motion: reduce)").matches) return closeAll();
    open.forEach(function (x) { x.classList.add("is-closing"); });
    setTimeout(closeAll, 240);
  }
  function openCart() {
    closeAll();
    dCart.innerHTML =
      '<div class="drawer__h drawer__h--cart"><span>' + TC("title", L("O teu carrinho", "Your cart")) + " • " + cartTotals().n + '</span><button class="ico" data-close aria-label="' + L("Fechar", "Close") + '">✕</button></div><div class="drawer__body" id="dc-body"></div>';
    renderCart(document.getElementById("dc-body"));
    overlay.hidden = dCart.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function openMenu() {
    closeAll();
    dMenu.innerHTML =
      '<div class="drawer__h"><span>Menu</span><button class="ico" data-close aria-label="' + L("Fechar", "Close") + '">✕</button></div><nav class="mm">' +
      // links do menu do telemóvel vêm de Navegação da Shopify (section Cabeçalho); destaques no início, letra pequena no fim
      (function () {
        var M = window.NZMENU || { top: 0, small: 0, links: [] }, n = M.links.length;
        return M.links.map(function (l, i) {
          var cls = i < M.top ? ' class="mm__p"' : i >= n - M.small ? ' class="mm__s"' : "";
          return (i === M.top && M.h ? '<p class="mm__h">' + esc(M.h) + "</p>" : "") + '<a' + cls + ' href="' + esc(l[1]) + '">' + esc(l[0]) + "</a>";
        }).join("");
      })() + (window.NZLOC ? NZLOC.menuLink() : "") + '</nav>';
    dMenu.querySelectorAll("a").forEach(function (a) {
      a.setAttribute("data-link", "");
    });
    overlay.hidden = dMenu.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function openSearch() {
    closeAll();
    sBar.hidden = false;
    var i = sBar.querySelector("input");
    i.value = "";
    $("#search-res").innerHTML = "";
    i.focus();
  }
  sBar.querySelector("input").addEventListener("input", function () {
    var q = this.value.trim().toLowerCase();
    var hs =
      q.length < 2
        ? []
        : Object.keys(P)
            .filter(function (h) {
              return P[h].t.toLowerCase().indexOf(q) > -1;
            })
            .slice(0, 6);
    $("#search-res").innerHTML = hs
      .map(function (h) {
        return (
          '<a href="/products/' +
          h +
          '" data-link><img src="' +
          img(P[h].i[0], 240) +
          '" alt="">' +
          esc(P[h].t) +
          "<br><b>" +
          money(P[h].p) +
          "</b></a>"
        );
      })
      .join("");
  });

  // quem chega de um anúncio de memória (utm_content com memor, colibri ou hummingbird) fica em modo calmo a sessão toda
  try { if (/memor|colibri|hummingbird/i.test(new URLSearchParams(location.search).get("utm_content") || "")) sessionStorage.setItem("nz-calm", "1"); } catch (e) {}
  function calmAd() { try { return !!sessionStorage.getItem("nz-calm"); } catch (e) { return false; } }
  /* ---------- router ---------- */
  // secções adicionadas no editor ("Adicionar secção": texto, imagem, imagem com texto, linha de peças) aparecem no fim da página
  function extras() {
    var srv = document.getElementById("srv");
    if (DESIGN || !srv || srv.classList.contains("show")) return;
    if (app.querySelector(".nz-extra")) return;
    srv.querySelectorAll(".nz-extra").forEach(function (el) {
      var c = el.cloneNode(true), id = el.getAttribute("data-nzprod"), x = id && (window.NZEXTRA || {})[id];
      if (x) {
        var ps = (x.ps || []).filter(function (h) { return P[h]; });
        if (!ps.length) ps = rank(CM[x.col] || []).slice(0, x.n);
        c.innerHTML = ps.length ? '<div class="sec page-width row-c">' + rowHead(esc(x.t || ""), x.col ? "/collections/" + x.col : "") + grid(ps.slice(0, x.n), x.col, true) + "</div>" : "";
      }
      app.appendChild(c);
    });
  }
  function route() {
    closeAll();
    var bar = document.getElementById("sticky-atc");
    bar.hidden = true;
    bar.classList.remove("on");
    var path = NZL.strip(location.pathname).replace(/\/+$/, "") || "/";
    var qs = new URLSearchParams(location.search);
    var m;
    if (path === "/") home();
    else if ((m = path.match(/^\/collections\/([^/]+)\/products\/([^/]+)$/)))
      product(decodeURIComponent(m[2]), m[1]);
    else if ((m = path.match(/^\/products\/([^/]+)$/)))
      product(decodeURIComponent(m[1]), null);
    else if ((m = path.match(/^\/collections\/([^/]+)$/)))
      collection(m[1], +qs.get("page") || 1);
    else if (path === "/cart") cartPage();
    else if (path === "/search") search(qs.get("q"));
    else if (window.NZPAGES && NZPAGES[path]) {
      document.body.classList.toggle("is-advertorial", !!NZPAGES[path].adv);
      NZPAGES[path].render();
      iconsRow(null);
      scrollTo(0, 0);
    } else if (/^\/(policies|account|challenge)/.test(path) || (/^\/pages\//.test(path) && document.querySelector("#srv .nz-page"))) {
      // páginas da própria Shopify (políticas, conta): mostrar o conteúdo do servidor
      app.innerHTML = "";
      var srv = document.getElementById("srv");
      if (srv) { srv.hidden = false; srv.classList.add("show"); }
      iconsRow(null);
    } else notFound();
    if (!(window.NZPAGES && NZPAGES[path] && NZPAGES[path].adv)) document.body.classList.remove("is-advertorial");
    // percurso de luto: sem barra de promoção nem selo de desconto
    var ph = (path.match(/\/products\/([^/]+)$/) || [])[1], pp = ph && P[decodeURIComponent(ph)];
    document.body.classList.toggle("is-calm", calmAd() || /^\/collections\/memoria/.test(path) || !!(pp && (pp.tg || []).indexOf("memoria") > -1));
    extras();
  }
  document.addEventListener("click", function (e) {
    var co = e.target.closest("[data-checkout]");
    if (co) {
      co.disabled = true;
      co.textContent = L("A abrir o pagamento seguro…", "Opening secure checkout…");
      var t = cartTotals();
      pushCart().then(function () {
        // o checkout do UK abria em português: o idioma vai explícito no link
        var co = NZL.u("/checkout") + (NZL.en ? "?locale=en" : "");
        location.href = t.credit ? (NZL.en ? co + "&discount=" + NZL.SALDO_CODE : "/discount/" + NZL.SALDO_CODE + "?redirect=%2Fcheckout") : co;
      }, function () { location.href = NZL.u("/cart"); });
      return;
    }
    var o = e.target.closest("[data-open]");
    if (o) {
      e.preventDefault();
      ({ cart: openCart, menu: openMenu, search: openSearch })[
        o.dataset.open
      ]();
      return;
    }
    if (e.target.closest("[data-close]") || e.target === overlay) {
      closeAnimated();
      return;
    }
    var rm = e.target.closest("[data-rm]"),
      cq = e.target.closest("[data-cq]");
    if (rm || cq) {
      if (rm) cart.splice(+rm.dataset.rm, 1);
      else {
        var l = cart[+cq.dataset.cq];
        l.q += +cq.dataset.d;
        if (l.q < 1) cart.splice(+cq.dataset.cq, 1);
      }
      saveCart();
      var host =
        document.getElementById("dc-body") && !dCart.hidden
          ? document.getElementById("dc-body")
          : document.getElementById("cart-page");
      if (host) renderCart(host);
      return;
    }
    // ponytail: produtos e coleções abrem com carregamento normal para os eventos da Shopify/Meta (ViewContent) dispararem
    var a = e.target.closest("a[data-link], .hdr__nav a, .hdr__logo, .ftr a");
    if (
      a && !DESIGN &&
      a.origin === location.origin &&
      !e.metaKey &&
      !e.ctrlKey &&
      !/^\/(policies|account|localization|products|collections)/.test(NZL.strip(a.pathname)) && !a.hasAttribute("data-native") &&
      !(/^\/pages\//.test(NZL.strip(a.pathname)) && !(window.NZPAGES && NZPAGES[NZL.strip(a.pathname).replace(/\/+$/, "")]))
    ) {
      e.preventDefault();
      if (a.href !== location.href)
        history.pushState(null, "", a.pathname + a.search);
      route();
      if (!/\/products\//.test(a.pathname) && !/page=/.test(a.search))
        scrollTo(0, 0);
    }
  });
  document.querySelectorAll(".ftr__t").forEach(function (t) {
    t.addEventListener("click", function () {
      t.parentNode.classList.toggle("open");
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeAnimated();
  });
  addEventListener("popstate", route);
  addEventListener("nz:remount", mount);
  var hdr = document.getElementById("hdr");
  addEventListener(
    "scroll",
    function () {
      hdr.classList.toggle("is-stuck", scrollY > 40);
    },
    { passive: true },
  );

  window.NZAPP = {
    app: app, img: img, money: money, esc: esc, grid: grid, card: card, svg: svg,
    wasOf: function (h, vi) { var v = P[h] && P[h].v[vi || 0]; return cmp(v, h) ? wasVal(v, h) : 0; },
    P: function () { return P; }, rate: function () { return RATE; }, size: function (h) { var x = SIZES[h]; return x && x.t ? L(x.t[0], x.t[1]) : ""; }, mapped: function (h) { return !!MAPPED[h]; }, addToCart: addToCart, addLines: addLines, cart: function () { return cart; }, etaText: function () { return L("Recebes entre " + eta(9) + " e " + eta(18) + ".", "Arrives between " + eta(NZL.ETA[0]) + " and " + eta(NZL.ETA[1]) + "."); }, openCart: openCart, cartTotals: cartTotals, cartIcon: function(){ return document.querySelector('.hdr__cart'); }, renderAgain: function(){ var h=document.getElementById('dc-body'); if(h&&!dCart.hidden) renderCart(h); var c=document.getElementById('cart-page'); if(c) renderCart(c); }
  };
  // no arranque só desenha o ponto do carrinho; o carrinho da Shopify manda e chega em load()
  saveCart(true);
  app.innerHTML = '<div style="min-height:70vh"></div>';
  load()
    .then(route)
    .catch(function (err) {
      app.innerHTML =
        '<p class="center sec">' + L("Erro a carregar o catálogo: ", "Couldn't load the catalogue: ") +
        esc(err.message) +
        "</p>";
    });
})();
// editor da Shopify: ao mexer nos blocos da section nz-pdp, lê a nova ordem e redesenha a página
document.addEventListener("shopify:section:load", function (e) {
  var h = e.target.innerHTML || "", m;
  if ((m = h.match(/window\.NZPDP=(\[[\s\S]*?\]);<\/script>/))) try { window.NZPDP = JSON.parse(m[1]); } catch (x) {}
  if ((m = h.match(/window\.NZHOME=(\[[\s\S]*?\]);<\/script>/))) try { window.NZHOME = JSON.parse(m[1]); } catch (x) {}
  if ((m = h.match(/window\.NZCOL=(\{[\s\S]*?\});<\/script>/))) try { window.NZCOL = JSON.parse(m[1]); } catch (x) {}
  window.dispatchEvent(new CustomEvent("nz:remount"));
  window.dispatchEvent(new PopStateEvent("popstate"));
});

// textos do site editáveis no editor (Definições do tema > Textos do site): "original => novo", uma linha cada;
// e, se os degraus Leva 2/3/4+ mudarem nas definições, os 15%/20%/25% escritos nos textos acompanham
(function () {
  var D = window.NZD || [0, 0, 15, 20, 25], MAP = { 15: D[2], 20: D[3], 25: D[4] }, pctOn = D[2] !== 15 || D[3] !== 20 || D[4] !== 25;
  var R = String(window.NZTXT || "").split(/\n/).map(function (l) { var i = l.indexOf("=>"); return i < 0 ? null : [l.slice(0, i).trim(), l.slice(i + 2).trim()]; }).filter(function (x) { return x && x[0]; });
  // ponytail: corre sempre (os blocos da página de produto podem ter textos e ícones próprios)
  var done = new WeakMap(), BR = null, BRsrc = null;
  // regras de cada bloco da página de produto (só valem dentro desse bloco)
  function blockRules(k) {
    if (BRsrc !== window.NZPDP) { BRsrc = window.NZPDP; BR = {}; (BRsrc || []).forEach(function (b) { var x = b.x || {}, raw = String((window.NZL && NZL.en ? x.en : x.pt) || ""); BR[b.t] = { r: raw.split(/\n/).map(function (l) { var i = l.indexOf("=>"); return i < 0 ? null : [l.slice(0, i).trim(), l.slice(i + 2).trim()]; }).filter(function (x) { return x && x[0] && x[0] !== x[1]; }), ic: x.ic || [] }; }); }
    return BR[k];
  }
  function icons(blk) {
    var k = blk.getAttribute("data-nzb"), br = blockRules(k); if (!br || !br.ic.some(Boolean)) return;
    [].forEach.call(blk.querySelectorAll("svg, img.nz-ic"), function (el, i) {
      var u = br.ic[i]; if (!u || el.tagName.toLowerCase() === "img") return;
      var r = el.getBoundingClientRect(), im = document.createElement("img");
      im.className = "nz-ic"; im.src = u; im.alt = ""; im.style.width = (r.width || 24) + "px"; im.style.height = (r.height || 24) + "px"; im.style.objectFit = "contain"; im.style.verticalAlign = "middle";
      el.parentNode.replaceChild(im, el);
    });
  }
  function fix(n) {
    if (n.nodeType === 3) {
      if (done.get(n) === n.nodeValue) return;
      var t = n.nodeValue;
      var bk = n.parentElement && n.parentElement.closest && n.parentElement.closest("[data-nzb]"), brr = bk && blockRules(bk.getAttribute("data-nzb"));
      if (brr) brr.r.forEach(function (r) { if (t.indexOf(r[0]) > -1) t = t.split(r[0]).join(r[1]); });
      if (pctOn) t = t.replace(/\b(15|20|25)(\s?%)/g, function (m, d, s) { return MAP[d] + s; });
      R.forEach(function (r) { if (r[0] === r[1]) return; if (t.trim() === r[0]) t = t.replace(r[0], r[1]); else if (r[0].length >= 12 && t.indexOf(r[0]) > -1) t = t.split(r[0]).join(r[1]); }); // texto inteiro sempre; pedaços só para frases (12+ letras), para "Sale" não mudar "Closing Sale"
      if (t !== n.nodeValue) n.nodeValue = t;
      done.set(n, t);
      return;
    }
    if (n.nodeType !== 1 || /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.nodeName)) return;
    if (n.closest) { var bb = n.hasAttribute && n.hasAttribute("data-nzb") ? n : n.closest("[data-nzb]"); if (bb) setTimeout(function () { icons(bb); }, 0); }
    if (n.placeholder) R.forEach(function (r) { if (n.placeholder === r[0]) n.placeholder = r[1]; });
    for (var c = n.firstChild; c; c = c.nextSibling) fix(c);
  }
  fix(document.body);
  new MutationObserver(function (ms) { ms.forEach(function (m) { if (m.type === "characterData") fix(m.target); else m.addedNodes.forEach(fix); }); }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
